module.exports = {
  common: {
    FindUs: 'Descubre nuestros productos y servicios',

    registeredAccount: 'Registrar una cuenta NTL',
    unlock: '¡Desbloquee NTL! Experimenta el poder del anonimato',
    invitation: 'Invitar a un amigo a NTL',
    closeTheDeal: 'Cierre su primera transacción',

    sloganthree: 'Tere tulemast NTL-i!',
    slogantwo: 'Descubre el universo único de NTL',
    slogantwo2: 'Mecanismo transparente, seguridad sin preocupaciones',
    currencySelection: 'vorm',
    chart: 'Diagramm',
    details: 'üksikasjad',
    entrust: 'usaldada',
    login: 'Iniciar sesión',
    register: 'Regístrate',
    loginregister: 'Iniciar sesión / Registrarse',
    indexplaceholde: 'correo electrónico',
    logout: 'Cerrar sesión',
    tip: 'Propina',
    signupnow: 'Inscrivez',
    logintip: 'por favor ingresa primero',
    expect: '¡Esperamos la expectativa!',
    delete: '¿Confirmas la eliminación?',
    nodata: 'Sin datos',
    set: 'Establecer',
    update: 'Modificar',
    slogan: 'Los 50 principales intercambios de divisas digitales del mundo',
    subslogan: 'Agencia estatal garantiza la seguridad de los activos',
    more: 'Más',
    please: 'Por favor',
    pleaseselect: 'Seleccione',
    searchplaceholder: 'Introduzca el símbolo de la moneda ...',
    searchplaceholderswap: 'Introduzca el símbolo de intercambio ...',
    loading: 'Cargando...',
    close: 'Cerca',
    ok: 'OKAY',
    fillComplete: 'Por favor complete la información completa',
    inputpleaseselect: 'Por favor, introduzca',
    showDetail: 'Vaata üksikasju',
  },
  header: {
    brandTitle1: 'Rahvusvaheline digitaalsete varade tuletisinstrumentide börs',
    index: 'Casa',
    otc: 'OTC',
    trade: 'Comercio',
    exchange: 'Intercambio',
    xiaoxi: 'Mensaje',
    kefu: 'Ayuda',
    login: 'INICIAR SESIÓN',
    register: 'REGISTRARSE',
    asset: 'ACTIVO',
    otcOrder: 'ORDEN',
    ucenter: 'CUENTA',
    service: 'Anuncio',
    downloadapp: 'Escanea el código para descargar e instalar',
    appdownlaod: 'Descargar aplicación',
    usercenter: 'Centro de usuarios',
    helpcenter: 'CENTRO DE AYUDA',
    aboutus: 'Acerca de',
    partner: 'Compañero',
    bzb: 'BZB ECO',
    assetmanage: 'Finanzas',
    trademanage: 'Intercambio',
    activity: 'Rayo',
    lab: 'Laboratorio NTL',
    ctc: 'Intercambio C2C',
    labdetail: 'NTL Lightning Lab',
    invite: 'Socio promotor',
    whitepaper: 'Papel blanco',
    scandownload: 'Descargar aplicación',
    innovationmanage: 'Innovación',
    swap1: 'Contrato Perpetuo (U)',
    swap2: 'Contrato perpetuo (estándar)',
    swap3: 'CFD',
    swap4: 'Segundo',
    cexchange: 'QuikExchange',
    option: 'Contrato de opción',
    news: 'Noticias',
    swapExchange: 'transacción de contrato',
    finance: 'Servicios financieros',
    fiatCurrency: 'Comprar cripto',
  },
  sectionPage: {
    global_leader: 'Líder mundial en intercambio de moneda digital',
    Professional:
      'El comercio profesional y la operación simple le permiten entender el comercio digital fácilmente',
    showMore: 'Vaata rohkem',
    brandDesc6:
      'NTLil on reaalajas plokiahela varade juurdepääsu funktsioon, mitme valuuta aadresside jagamise tehnoloogia, mitme turvalisuse kontrollimise kaitse ning tööstusharu plokiahela varade madalad tehingu- ja ekstraheerimiskulud.',
    brandDesc5:
      "NTL tehniline lahendus põhineb Google Cloudil ja Amazon AWS'il, mis tõhusalt takistab DDOS-rünnakuid ning toetab dünaamiliste ja staatiliste andmete eraldamist; Maailma juhtiv tehniline arhitektuur tagab kasutajate turvalised tehingud.",
    brandDesc4:
      'NTL pakub praegu ühekordseid krüptovarade teenuseid, nagu valuuta, püsiv leping, spot, optsioon, finantslaenud, ja toetab mitmeid keeleversioone, nagu hiina / inglise / jaapani / korea /.',
    brandDesc3:
      'NTL on pühendunud turvalisele, stabiilsele, mugavale, õiglasele ja mainekale plokiahela varade rahvusvahelisele vahetusele, mis väärib kasutajate usaldust ning tagab põhjalikult kasutajate kauplemisteabe ja -varade turvalisuse.',
    brandTitle2: 'Ühekordse krüpteerimise varade teenus',
    ptaqTitle: 'Seguridad de la plataforma',
    ptaqContent:
      'El algoritmo hash se utiliza para cifrar la autenticación de seguridad líder en el mundo',
    ptslTitle: 'Resistencia de la plataforma',
    ptslContent: 'La plataforma de comercio de bitcoins más grande del mundo',
    newsTitle: 'Centro de Noticias',
    brandTitle: 'Acerca de NTL',
    brandDetail: 'Honesto | Justo | Entusiasmo | Abierto',
    brandDesc1:
      'NTL fue fundado por un grupo de los primeros participantes y geeks de Bitcoin. Los miembros principales del equipo provienen de empresas reconocidas como Google, Microsoft, Alibaba, Tencent, etc. Tiene una gran capacidad de investigación y desarrollo y una rica experiencia en la operación de productos de Internet. ',
    brandDesc2:
      "NTL se encuentra en el proveedor de servicios básicos de blockchain, dedicado a proporcionar una plataforma de comercio de activos cifrados de alta calidad para usuarios globales, adhiriéndose al principio básico de 'NO SEA MALVADO', manteniendo un servicio honesto, justo y entusiasta a los clientes , y dar la bienvenida a todos los socios / proyectos que sean beneficiosos para los intereses fundamentales de los usuarios con una actitud abierta ",
    gettingstart: 'HOT | Guía para principiantes',
    officialstart: 'Servicio de atención al cliente oficial de NTL',
    oneminutebuy: 'Transacción de moneda',
    oneminutebuytips: 'Utilice un activo digital para intercambiarlo directamente por otro',
    baseknow: 'Contrato perpetuo',
    baseknowtips: 'T + 0 intercambio bidireccional de bienes virtuales como contrato de trueque',
    baseexchange: 'Contrato de opción',
    baseexchangetips: 'Es un derivado de activos digitales',
    usersocial: 'Intercambio rápido',
    usersocialtips: 'Intercambie activos digitales rápidamente',
    mainboard: 'Tablero principal',
    preview: 'Anterior',
    nextpage: 'Próximo',
    downloadwhite: 'Descargar el informe técnico',
  },
  nav: {
    ptjy: 'Plataforma de comercio',
    ptaq: 'Seguridad de la plataforma',
    ptsl: 'Resistencia de la plataforma',
    xwzx: 'Centro de Noticias',
    fabu: 'publicidad',
  },
  progress: {
    already: 'Tengo que cavar',
    total: 'Cantidad de mineral excavable 6 mil millones de BHB',
  },
  service: {
    USDT: 'USDT',
    BTC: 'BTC',
    ETH: 'ETH',
    CUSTOM: 'Favor',
    COIN: 'Moneda',
    symbol: 'Par de transacciones',
    favor: 'Favor',
    NewPrice: 'Último',
    ExchangeNum: 'Cantidad',
    FeePercent: 'Tasa de financiación',
    Change: 'Cambio',
    OpenPrice: 'Precio de apertura',
    PriceTrend: 'Tendencia de precios',
    Operate: 'Operar',
    Exchange: 'Intercambio',
    trading: 'Intercambio',
    high: 'Superior',
    low: 'Inferior',
  },
  exchange: {
    loginBuy: 'Osta pärast sisselogimist (BTC)',
    loginOut: 'Müük pärast sisselogimist (BTC)',
    coin: 'Moneda',
    symbol: 'Par de transacciones',
    lastprice: 'Último',
    daychange: 'Cambio',
    market: 'Mercados',
    favorite: 'Marcado',
    do_favorite: 'Recogido',
    cancel_favorite: 'Cancelar recopilado',
    type: 'Tipo',
    dealamount: 'Importe final',
    high: 'Alto',
    low: 'Bajo',
    vol: '24 H Vol',
    buy: 'Comprar',
    sell: 'Vender',
    limited_price: 'Precio limitado',
    market_price: 'Precio de mercado',
    fees_rate: 'tasa de tarifa',
    balance: 'saldos',
    or: 'o',
    starttrade: '¡Negocia ahora!',
    canuse: 'Disponible',
    recharge: 'Depósito',
    buyprice: 'Precio de compra',
    buynum: 'Importe de compra',
    amount: 'Cantidad',
    buyin: 'Comprar',
    disablebuyin: 'Compra en el mercado inhabilitada',
    buytip: 'Compra óptima',
    sellprice: 'Precio de venta',
    sellnum: 'Importe de venta',
    sellout: 'Vender',
    disablesellout: 'Venta de mercado inhabilitada',
    selltip: 'Venta óptima',
    curdelegation: 'Delegado',
    hisdelegation: 'Delegado de Historia',
    realtransaction: 'Operaciones de mercado',
    num: 'Cantidad',
    price: 'Precio',
    direction: 'Dirección',
    time: 'Hora',
    stall: 'Puesto',
    total: 'Total',
    traded: 'Hecho',
    action: 'Acción',
    undo: 'Deshacer',
    delegationnum: 'Importe delegado',
    done: 'Hecho',
    status: 'Estado',
    finished: 'Terminado',
    canceled: 'Cancelado',
    parted: 'Parted',
    tip: 'Propina',
    buyamounttip: 'ingrese el monto de la compra',
    buyamounttipwarning: 'comprar cantidad no más',
    success: '¡entregar el éxito!',
    pricetip: 'ingrese el precio de compra',
    pricetipwarning: 'precio de compra no más',
    sellamounttip: 'ingrese el monto de venta',
    sellamounttipwarning: 'vender cantidad no más',
    sellpricetip: 'ingrese el precio de venta',
    sellpricetipwarning: 'precio de venta no más',
    undotip: '¿Confirmar Deshacer?',
    cancelsuccess: 'Cancelar pedido con éxito',
    marketprice: 'Precio de mercado',
    expand: {
      time: 'hora',
      price: 'precio',
      amount: 'cantidad',
      fee: 'tarifa',
    },
    realtime: 'tiempo real',
    kline: 'KLine',
    depth: 'Profundidad',
    publishstate0: 'Está a punto de comenzar. Espere ...',
    publishstate1: 'Está a punto de terminar. Espere ...',
    publishstate2: 'Consolidación de pedidos, espere ...',
    publishstate3: 'La consolidación ha terminado. Por favor, intercambie gratis ...',
    publishdetail: 'Más detalles',
    publishprice: 'Precio',
    publishamount: 'Cantidad',
    publishcounttxt0: 'Comenzar después de',
    publishcounttxt1: 'Finalizar después de',
    publishcounttxt2: 'Libre comercio después',
    publishcounttxt3: '¡Actividad terminada!',
    dateTimeDay: 'D',
    dateTimeHour: 'H',
    dateTimeMinutes: 'M',
    dateTimeSeconds: 'S',
    moredetail: 'Ver más',
  },
  swap: {
    contract: 'Contrato',
    swapindex: 'SWAP',
    coin: 'Moneda',
    symbol: 'Par de monedas',
    volume: 'Volumen',
    lastprice: 'Último',
    daychange: 'Cambio',
    market: 'Mercados',
    favorite: 'Marcado',
    do_favorite: 'Recogido',
    cancel_favorite: 'Cancelar recopilado',
    type: 'Tipo',
    dealamount: 'Importe final',
    high: 'Alto',
    low: 'Bajo',
    vol: '24 H Vol',
    buy: 'Comprar',
    sell: 'Vender',
    limited_price: 'Precio limitado',
    market_price: 'Precio de mercado',
    spot_price: 'Precio de activación',
    fees_rate: 'tasa de tarifa',
    balance: 'saldos',
    or: 'o',
    starttrade: '¡Negocia ahora!',
    canuse: 'Disponible',
    recharge: 'Depósito',
    buyprice: 'Precio de compra',
    buynum: 'Importe de compra',
    amount: 'Cantidad',
    buyin: 'Comprar',
    disablebuyin: 'Compra en el mercado inhabilitada',
    buytip: 'Compra óptima',
    sellprice: 'Precio de venta',
    sellnum: 'Importe de venta',
    sellout: 'Vender',
    disablesellout: 'Venta de mercado inhabilitada',
    selltip: 'Venta óptima',
    curdelegation: 'Delegado',
    hisdelegation: 'Delegado de Historia',
    realtransaction: 'Operaciones de mercado',
    num: 'Cantidad',
    price: 'Precio',
    direction: 'Dirección',
    time: 'Hora',
    stall: 'Puesto',
    total: 'Total',
    traded: 'Hecho',
    action: 'Acción',
    undo: 'Deshacer',
    delegationnum: 'Importe delegado',
    done: 'Hecho',
    status: 'Estado',
    finished: 'Terminado',
    canceled: 'Cancelado',
    parted: 'Parted',
    tip: 'Propina',
    buyamounttip: 'ingrese el monto de la compra',
    buyamounttipwarning: 'comprar cantidad no más',
    success: '¡entregar el éxito!',
    pricetip: 'ingrese el precio de compra',
    pricetipwarning: 'precio de compra no más',
    sellamounttip: 'ingrese el monto de venta',
    sellamounttipwarning: 'vender cantidad no más',
    sellpricetip: 'ingrese el precio de venta',
    sellpricetipwarning: 'precio de venta no más',
    undotip: '¿Confirmar Deshacer?',
    cancelsuccess: 'Cancelar pedido con éxito',
    marketprice: 'Precio de mercado',
    expand: {
      time: 'hora',
      price: 'precio',
      amount: 'cantidad',
      fee: 'tarifa',
    },
    realtime: 'tiempo real',
    kline: 'KLine',
    depth: 'Profundidad',
    open: 'Abierto',
    close: 'Cerca',
    latestdeal: 'Oferta más reciente',
    myswapaccount: 'Mi cuenta de intercambio',
    accountmode: 'Pattren',
    accountmargin: 'Apalancamiento',
    accountquanyi: 'Capital',
    profitandloss: 'P / L no realizado',
    principalAmount: 'Margen disponible',
    positionAmount: 'Margen utilizado',
    frozenAmount: 'Margen congelado',
    principalRate: 'Relación de margen',
    zijinhuazhuan: 'Transferir',
    up: 'L',
    down: 'S',
    canup: 'Max. L',
    candown: 'Max. S',
    cancloseup: 'Max (S)',
    canclosedown: 'Max (L)',
    openup: 'Abierto largo',
    opendown: 'Abrir corto',
    closeup: 'Cerrar corto',
    closedown: 'Cerrar largo',
    currentposition: 'Posiciones abiertas',
    assetsdetail: 'Transacciones',
    marginMode1: 'Fijo',
    marginMode2: 'Cruzar',
    modifyMarginModeTitle: 'Modificar el modo de margen de cuenta',
    modifyLeverage: 'Ajustar apalancamiento',
    moredetail: 'Ver más',
    shareNumber: 'Cont',
    entrustprice: 'Precio',
    triggleprice: 'Activador',
    openvolume: 'Volumen largo',
    closevolume: 'Volumen corto',
    triggleplaceholder: 'El precio predeterminado es el mercado',
    marketpriceplaceholder: 'Negociará al mejor precio',
    levmaxtip: 'El apalancamiento no debe superar el máximo',
    levmintip: 'El apalancamiento no debe ser inferior al mínimo',
    marginModeSuccessTip: 'Modificar éxito.',
    noenoughbalance: 'Saldo insuficiente',
    pleaseinputopenvolume: 'El volumen debe ser superior a 0',
    pleaseinputcorrectopenvolume: 'Ingrese el volumen correcto',
    pleaseinputrightentrustprice: 'Por favor ingrese el precio correcto',
    noenoughposition: 'Posición insuficiente',
    pleaseinputclosevolume: 'El volumen debe ser superior a 0',
    pleaseinputcorrectclosevolume: 'Ingrese el volumen correcto',
    pos_Pl: 'PL.',
    pos_Ratio: 'Relación PL',
    pos_pos: 'Posición',
    pos_canClose: 'Posición Ava',
    pos_openPrice: 'Precio de apertura',
    pos_leverage: 'Apalancamiento',
    pos_margin: 'Margen cur',
    pos_mRatio: 'Relación de margen',
    pos_cmRatio: 'Relación de mantenimiento',
    pos_long: 'Largo',
    pos_short: 'Corto',
    ent_entrustType: 'Abierto cerrado',
    ent_direction: 'Dirección',
    ent_type: 'Tipo',
    ent_trigglePrice: 'Precio de activación',
    ent_entrustPrice: 'Entrust Price',
    ent_tradedPrice: 'Precio negociado',
    ent_margin: 'Margen',
    ent_volume: 'Volumen',
    ent_status: 'Estado',
    ent_status1: 'Confiar',
    ent_status2: 'Cancelado',
    ent_status3: 'Entrust fallido',
    ent_status4: 'Negociado',
    ent_statusblast: 'Explosión',
    ent_pl: 'P / L',
    ent_fee: 'Tarifa',
    triggerpriceshouldbigger: 'El precio de activación debe ser superior a 0',
  },
  second: {
    balance: 'Equilibrio',
    profitability: 'Rentabilidad',
    opentime: 'Tiempo abierto',
    transactionMode: 'Modo de transacción',
    currentPosition: 'Posición actual',
  },
  ctc: {
    title: 'Venta con un clic ● Garantía de la plataforma ● Seguridad',
    desc: 'Los activos criptográficos son administrados por NTL y el aceptante proporciona servicios de intercambio para el intercambio',
    buyin: 'Comprar',
    sell: 'Vender',
    buyprice: 'Precio de compra',
    sellprice: 'Precio de venta',
    buynum: 'Importe de compra',
    sellnum: 'Importe de venta',
    payamount: 'Pago',
    getamount: 'Pago',
    avabalance: 'Disponible',
    time: 'Fecha de negociación',
    tip: 'Darse cuenta',
    notice: 'Darse cuenta',
    notice1:
      '1. El área de comercio de moneda legal es una transacción de activos entre usuarios y aceptantes. Los fondos no se transfieren a una plataforma y la plataforma no acepta recargas / remesas de RMB ；',
    notice2:
      '2. Los aceptantes de transacciones en moneda legal han pasado la certificación de nombre real, ofreciendo márgenes de transacción, y los tokens están alojados en la plataforma, por lo que puede estar seguro de que se pueden convertir ；',
    notice3:
      '3. El tiempo de servicio del aceptante es de 09: 00-21: 00 por día. La aceptación se completa dentro de los 30 minutos posteriores a la aceptación del pedido, y la transacción incompleta de dos horas se cancela ；',
    notice4:
      '4. Para admitir tarjetas bancarias en el área de comercio de moneda legal, es necesario transferir fondos utilizando una cuenta que haya autenticado con su nombre real ；',
    notice5:
      '5. Para garantizar la seguridad de los fondos de la transacción, la transacción en moneda legal requiere que los usuarios pasen la autenticación de nombre real ；',
    payType: 'Cuenta de pago',
    receiveType: 'Recibir cuenta',
    moneyTips:
      'El precio anterior es solo para referencia. Consulte el monto de liquidación real después del siguiente pedido.',
    verifyset: 'Nombre real / Contraseña de activo',
    payset: 'Configuración de pago',
    trade: 'Intercambio',
    input50tips: 'Introduzca un número entre 50 y 50.000',
    bank: 'Tarjeta bancaria',
    alipay: 'Alipay',
    wechatpay: 'Wechat',
    payaccountset: 'Configuración de la cuenta de pago',
    useselfaccount: 'Asegúrese de utilizar su cuenta autenticada con nombre real',
    orderSn: 'N º de pedido.',
    tradetime: 'Fecha de intercambio',
    direction: 'Dirección',
    amount: 'Importe (USDT)',
    money: 'Total (CNY)',
    price: 'Precio (CNY)',
    status: 'Estado',
    operate: 'Operar',
    moredetail: 'Más detalles',
  },
  cexchange: {
    use: 'tarbida',
    consume: 'vahetamine',
    title: 'Conversión rápida',
    desc: 'Un clic,Obtenga ganancias todos los días',
    quantity: 'Cantidad de compra de actividad',
    inputtips1: 'El número de personalización',
    choosecurrency: 'Elija una moneda',
    all: 'Todas',
    maxtip: 'Canje máximo ',
    mintip: 'intercambio mínimo ',
    totalpay: 'Moneda Importe pagado',
    restricted: 'El total restringido hoy',
    currentprice: 'Precio actual',
    nextprice: 'Precio de la próxima edición',
    confirmpay: 'Confirmar pago',
    assets: 'tasakaal ：',
    loginFirst: 'Por favor Iniciar sesión',
    success: '¡Felicitaciones, intercambio exitoso!',
    tip: 'Consejos',
    confirm: 'Confirmar sugerencias',
    confirmmsg: '¿Estás seguro de cambiar BZB?',
    ok: 'OKAY',
    cancel: 'Cancelar',
  },
  option: {
    title: 'Contrato de opción',
    buyupreward: 'Comprar fondo de recompensas',
    buydownreward: 'Vender fondo de recompensas',
    quantity: 'Monto de la apuesta',
    myamount: 'Importe de mi apuesta',
    buyup: 'Precio alto',
    buydown: 'Precio bajo',
    history: 'Historia',
    seriers: 'No.',
    period: '',
    currentoption: 'Intervalo de tiempo',
    openprice: 'Precio de apertura',
    currentprice: 'Precio actual',
    openprice1: 'Precio de apertura',
    closeprice: 'Precio de cierre',
    opentime: 'Tiempo abierto',
    closetime: 'Hora de cierre',
    progress: 'Progreso',
    loginFirst: '¡Por favor ingresa primero!',
    selectAmount: 'Seleccione su importe',
    balancenotenough: '¡Banlance no es suficiente!',
    betsuccess: 'Felicitaciones！ Apuesta exitosa！',
    noopening: '¡No hay apertura ahora!',
    col_createTime: 'Crear tiempo',
    col_direction: 'Dirección',
    col_result: 'Resultado',
    col_optionNo: 'No.',
    col_betAmount: 'Monto de la apuesta',
    col_rewardAmount: 'Importe de la recompensa',
    col_fee: 'Cuota de apertura',
    col_winfee: 'Tarifa de recompensa',
    win: 'Ganar',
    lose: 'Perder',
    wait: 'Apertura',
    avaliablebalance: 'Saldo disponible',
    login: 'Por favor Iniciar sesión',
    kline: 'Mercado en tiempo real',
  },
  otc: {
    payment_detail: 'Detalles del método de pago',
    bind_payment: 'Vincular el método de pago',
    payment_placeholder: 'Seleccione un método de pago',
    payment: 'Método de pago',
    ad: 'Publicidad',
    buyin: 'Comprar',
    sellout: 'Vender',
    merchant: 'Comerciante',
    applymerchant: 'Aplicar comerciante',
    volume: 'Volumen',
    paymethod: 'Método de pago',
    amount: 'Cantidad',
    price_coin: 'Precio / Moneda',
    operate: 'Acción',
    validate: 'Verifique primero',
    sell: 'vender',
    buy: 'comprar',
    transaction: 'Transacciones comerciales',
    buttontxt: 'Conviértase en comerciante',
    title: 'Cambio OTC',
    desc: 'Venta cómoda, segura y rápida de moneda digital',
    title1: 'Ajuste dinámico',
    desc1: 'Fluctuación en tiempo real según el precio de mercado',
    title2: 'Sin cargo',
    desc2:
      'Lo que ves es lo que obtienes. Además del precio de venta, no hay cargo por servicio para la plataforma',
    title3: 'Transacción inmediata',
    desc3:
      'La introducción de servicios de plataforma para comerciantes, emparejamiento inteligente, cierre de pedidos, sin necesidad de esperar al emparejamiento',
    title4: 'Garantía de la plataforma',
    desc4:
      'Empresa de certificación de plataforma, seguridad garantizada, servicio de atención al cliente 24 horas para la transacción de acompañamiento',
    myad: {
      title: 'Mi anuncio',
      post: 'Publica un anuncio',
      alert:
        '【Consejo】 ： Cuando la cantidad mínima de compras publicitarias más la tarifa es mayor que el número restante de anuncios, el anuncio se retira automáticamente del estante.',
      no: 'No',
      type: 'tipo',
      sell: 'vender',
      buy: 'comprar',
      limit: 'límite',
      remain: 'importe restante',
      coin: 'moneda',
      created: 'Fecha de creación',
      operate: 'acción',
      errmsg: 'Puede editarse y modificarse después de que el anuncio se caiga',
      update: 'editar',
      shelf: 'estante',
      dropoff: 'bajar ó dejar algo',
      delete: 'Eliminar',
    },
    myorder: 'Mi pedido',
    chatline: {
      status_1: 'El comprador no pagó y esperó a que el comprador pagara！',
      status_2: 'El comprador ha pagado y espera que el vendedor libere！',
      status_3: 'Pedido completado transacción！',
      status_4: 'Se está apelando la orden！',
      status_5: '¡Orden cancelada!',
      loadmore: 'Carga más',
      warning:
        'Alertas antifraude: en el pasado reciente, los estafadores han utilizado repetidamente información de remesas de transferencias bancarias y credenciales de remesas falsas para el fraude, así que asegúrese de verificar su propio número de cuenta de pago. Garantice la seguridad de los fondos de remesas y evite tarjetas bancarias congeladas！ ',
      contenttip: 'Ingrese el contenido del chat Ingrese la clave para enviar',
      contentmsg: 'El mensaje no puede estar vacío',
    },
    chat: {
      seller: 'Vendedor',
      buyer: 'Comprador',
      exchangeamount: 'Importe de cambio',
      operatetip: 'Operar punta',
      operatetip_1:
        'Complete el pago de acuerdo con la cuenta proporcionada por la otra parte dentro del límite de tiempo y haga clic en esta página',
      finishpayment: 'pago completado',
      operatetip_1_1:
        'Tenga en cuenta en los comentarios cuando transfiera el número de referencia del buen pago',
      operatetip_1_2:
        'Después de recibir el pago, el vendedor confirmará el pago en el sitio web. El sistema enviará automáticamente los activos digitales que ha comprado a su cuenta. Tenga en cuenta que',
      note: 'Nota',
      notetip:
        'Por favor, no use otro software de chat para comunicarse entre sí, y no acepte ningún documento, adjunto de correo electrónico, etc. que le envíe la dirección. Todos los enlaces de comunicación se completan en la ventana de chat en esta página.',
      operatetip_2_1:
        'Los activos digitales que ha vendido se han enviado a la plataforma para su alojamiento y congelación. Ha confirmado su pago, haga clic',
      operatetip_2_2:
        'No crea ningún motivo para instar a que se libere la moneda, confirme la recepción del dinero y libere los activos digitales para evitar pérdidas！',
      operatetip_2_3:
        'Después de recibir el mensaje corto de la cuenta, asegúrese de iniciar sesión en la banca en línea o en la banca móvil para confirmar si el pago se contabiliza, para evitar la liberación falsa de activos digitales debido a la recepción de mensajes fraudulentos！',
      confirmrelease: 'Confirmar liberación',
      paydigital: 'Pagar activos digitales',
      orderstatus: 'Estado del pedido',
      orderstatus_1: 'pago completado',
      orderstatus_2: 'Apelación de la orden',
      orderstatus_3: 'Confirmar liberación',
      orderstatus_4: 'cancelar el trato',
      orderstatus_5: 'Apelación de la orden',
      order: 'Orden',
      and: 'y',
      transition: 'intercambio',
      transprice: 'Precio de negociación',
      transnum: 'Número de negociación',
      transmoney: 'Importe de negociación',
      tip1: 'El usuario aún no ha agregado el número de tarjeta bancaria',
      tip2: 'El usuario no ha agregado la cuenta de Alipay por el momento',
      tip3: 'El usuario aún no ha agregado la cuenta de WeChat',
      zfb: 'Alipay',
      wx: 'WeChat',
      qrcode: 'Código QR',
      msg1: '¿Está seguro de haber pagado?',
      msg2: '¡Los pagos no son reembolsables! ¿Está seguro de cancelar su pedido?',
      msg3: '【Repetir】 ： ¡Los pagos no son reembolsables! ¿Está seguro de cancelar su pedido?',
      msg4: 'Pagado, no recibido',
      msg5: 'Ya pagado, no recibido',
      tip: 'Propina',
      comptype: 'Tipo de queja',
      compremark: 'Nota de queja',
      willcomp: 'Quiero quejarme',
      msg6: '¿Confirma la liberación de moneda?',
      result_1: 'A la espera del pago',
      result_2: 'Esperando lanzamiento',
      result_3: 'Completado',
      result_4: 'Apelando',
      result_5: 'Cancelado',
      msg7: 'Contraseña del fondo',
      msg7tip: 'ingrese la contraseña del fondo',
    },
    checkuser: {
      emaildone: 'Correo electrónico certificado',
      emailundo: 'Correo electrónico no autorizado',
      teldone: 'Certificado Telno',
      telundo: 'Telno no autorizado',
      idcarddone: 'Certificado IDCard',
      idcardundo: 'IDCard no autorizada',
      language: 'idioma',
      languagetext: 'Chino',
      languagetext1: 'English',
      registtime: 'Hora de registro',
      exchangetimes: 'Transacciones acumuladas',
      exchangeinfo: 'Información comercial',
      tablabel1: 'Vender online',
      tablabel2: 'Comprar en linea',
      col_symbol: 'Moneda',
      col_paymode: 'Método de pago',
      col_num: 'Cantidad',
      col_price: 'Precio',
      col_created: 'Tiempo de liberación',
      col_operate: 'Operar',
      operatemsg: 'Realice primero la autenticación del nombre real',
      buyin: 'Aceptacion',
      sellout: 'Vendido',
    },
    tradecenter: {
      postad: 'Publica un anuncio',
      exchange: 'Transacción de GCC',
      buyin: 'Quiero comprar',
      sellout: 'Quiero venderme',
    },
    tradeinfo: {
      emaildone: 'Correo electrónico certificado',
      emailundo: 'Correo electrónico no autorizado',
      teldone: 'Certificado Telno',
      telundo: 'Telno no autorizado',
      idcarddone: 'Certificado IDCard',
      idcardundo: 'IDCard no autorizada',
      exchangetimes: 'Horarios de intercambio',
      price: 'Precio',
      num: 'Cantidad',
      paymethod: 'Método de pago',
      exchangelimitamount: 'Límite de cambio',
      location: 'Ubicación',
      location_text: 'China',
      exchangeperiod: 'Período de intercambio',
      minute: 'min',
      amounttip: 'Introduzca la cantidad',
      numtip: 'Ingrese el número',
      remarktip: 'Cuéntale tu solicitud',
      remarktitle: 'Horizon Remarks',
      exchangetitle: 'Información comercial',
      exchange_tip1:
        'Después de iniciar la solicitud de transacción, la moneda digital está bloqueada en el alojamiento y protegida por la plataforma. Si usted es un vendedor, después de iniciar una solicitud de transacción, puede recargar y esperar a que el comprador pague. Los compradores pagan dentro del plazo de pago. Después de recibir el pago, debe liberar la moneda digital que está bajo su custodia. ',
      exchange_tip2:
        'Lea antes de operar 《Condiciones de servicio de la red de plataforma》 y preguntas frecuentes, guías de operaciones y otra documentación de ayuda',
      exchange_tip3:
        '¡Cuidado con el mentiroso! Antes de la transacción, verifique la calificación recibida por el usuario y preste más atención a la cuenta recién creada',
      exchange_tip4:
        'Tenga en cuenta que el redondeo y las fluctuaciones de precios pueden afectar la cantidad de moneda digital que finalmente se negocia. La cantidad fija que ingrese determina la cantidad final, y la cantidad de la moneda digital se calculará a partir del tipo de cambio instantáneo al mismo tiempo que el se emite la solicitud. ',
      exchange_tip5:
        'Los servicios de alojamiento protegen tanto a los compradores como a los vendedores de transacciones en línea. En caso de una disputa, evaluaremos toda la información proporcionada y entregaremos la moneda digital alojada a su propietario legal',
      warning1: 'Introduzca hasta 2 decimales',
      warning2: 'El monto del pedido es',
      warning3: 'Introduzca hasta 8 decimales',
      warning4: 'La cantidad del pedido es',
      confirmbuyin: 'Confirmar compra',
      confirmsellout: 'Confirmar venta',
      buyin: 'Aceptacion',
      sellout: 'Vendido',
      warning5: 'Por favor complete el pedido según sea necesario',
    },
    publishad: {
      createad: 'Crear una oferta publicitaria',
      msg1: 'Si comercia con frecuencia, puede crear su propio anuncio comercial. Si solo comercia ocasionalmente, le recomendamos que busque directamente',
      msg2: 'Crear un anuncio comercial es',
      msg3: 'Gratis',
      msg4: 'Si desea editar directamente los anuncios creados, marque',
      tradead: 'Publicidad comercial',
      myad: 'Mi anuncio',
      iwant: 'Quiero',
      sellonline: 'vender online',
      buyonline: 'comprar en linea',
      exchangecoin: 'Moneda de cambio',
      country: 'País',
      currency: 'Moneda',
      openfixedprice: 'Precio fijo abierto',
      open: 'Abierto',
      close: 'Cerca',
      usetip:
        'Cuando está habilitado, el precio de su moneda no fluctuará con el mercado y el precio no cambiará',
      premiseprice: 'Premium',
      premisepricetip: 'Establezca su prima',
      fixedprice: 'Precio fijo',
      fixedpricetip: 'Introduzca su precio de cambio',
      marketprice: 'Precio de referencia del mercado',
      marketpricetip:
        'La prima se refiere a qué porcentaje es más alto que el precio de mercado actual',
      exchangeprice: 'Precio de cambio',
      formual: 'Fórmula de precios',
      num: 'Cantidad',
      num_text1: 'Introduzca lo que desee',
      num_text2: 'num',
      exchangeperiod: 'Periodo de transacción',
      exchangeperiod_text1: 'Introduzca su fecha límite de negociación',
      minute: 'min',
      tip1: 'Cuánto tiempo el comprador puede aceptar transacciones, ingrese un número entero',
      tip2: '【Sugerencia】 Se puede vincular al centro personal / Agregar método de pago',
      tip3: 'Ingrese el monto mínimo de su transacción',
      tip4: 'Ingrese el monto máximo de su transacción',
      tip5: 'Puede completar sus requisitos especiales en la información de comentarios, como: requisitos del comprador, tiempo en línea, etc.',
      paymode: 'Método de pago',
      minlimit: 'Importe mínimo de la transacción',
      maxlimit: 'Importe máximo de la transacción',
      remark: 'Comentarios',
      openautoreply: 'Abrir respuesta automática',
      msg5: 'Cuando está habilitado, cuando el usuario le inicia una transacción a través de este anuncio, el sistema envía automáticamente la frase de respuesta automática que seleccionó a la otra parte.',
      autoreply: 'Respuesta automática',
      autoreplytip:
        'Después de recibir el pedido, la información se devuelve automáticamente al comprador, por ejemplo: método de pago, número de cuenta de cobro, etc.',
      fundpwd: 'Contraseña del fondo',
      fundpwdtip: 'Introduzca su contraseña de fondos',
      submit: 'Enviar',
      warning1: 'Introduzca el número correcto',
      warning2: 'El valor de desbordamiento es 0-20',
      warning3: '¡Ingrese el monto máximo de su transacción!',
      warning4: 'Introduzca un número entero',
      warning5:
        '¡El monto máximo de la transacción debe ser mayor que el monto mínimo de la transacción!',
      warning6: 'El monto máximo de la transacción no puede exceder el monto total de la venta',
      warning7: '¡Ingrese el monto mínimo de su transacción!',
      warning8: '¡El monto mínimo de la transacción debe ser mayor o igual a 100!',
      warning9:
        'El monto mínimo de la transacción debe ser menor que el monto máximo de la transacción',
      sellout: 'Vender',
      buyin: 'Comprar',
      inputtip1: 'Ingrese la moneda',
      inputtip2: 'Introduzca la opción correcta',
      inputtip3: 'El valor de desbordamiento es 0-20 y no puede ser 0',
      inputtip4: 'Ingrese el precio fijo correcto',
      inputtip5:
        'Introduzca el número correcto y el número máximo de transacciones no supere las 100',
      inputtip6: 'Introduzca la fecha límite de negociación correcta',
      inputtip7: 'Seleccione el método de transacción',
      inputtip8: 'Introduzca la contraseña de fondos',
      zfb: 'Alipay',
      wx: 'Wechat',
      unionpay: 'BankCard',
      submit_failure: '¡Fracaso!',
      submittip1: 'Continúe con una serie de certificaciones, como nombres reales',
      submittip2: 'Realice una serie de certificaciones, como teléfonos móviles',
      submittip3: 'Continúe con una serie de certificaciones, como contraseñas en mayúsculas',
      submittip4: 'Vincula al menos una forma de pago',
    },
    index: {
      title: 'Buena recomendación publicitaria',
      exchangetimes: 'Tiempos de transacción',
      exchangeprice: 'Precio de transacción',
      exchangelimit: 'Límite de transacciones',
      paymode: 'Método de pago',
      buy: 'comprar',
      sell: 'vender',
      viewmore: 'Más',
      bot1: 'Seguro y confiable',
      bot1_tip:
        'Más de 10 años de experiencia en el equipo de control de riesgos financieros  nSistema de políticas de seguridad personalizable',
      bot2: 'Rapido y facil',
      bot2_tip:
        'Compatibilidad con el modo de transacción gratuita de usuario de igual a igual  nTipos de canales de intercambio de dinero',
      bot3: 'Moneda completa',
      bot3_tip:
        'Selección de las principales monedas de transacciones de activos digitales  nExperiencia comercial de múltiples activos',
      ibuy: 'Quiero comprar',
      isell: 'Quiero vender',
    },
  },
  activity: {
    all: 'Todas',
    prepare: 'Viniendo',
    ongoing: 'En marcha',
    distributing: 'Distribuyendo',
    completed: 'Completado',
    progress: 'Progreso',
    totalsupply: 'Suministro total',
    starttime: 'Fecha de inicio',
    endtime: 'Fecha final',
    viewdetail: 'Detalle',
    attend: 'Asistir',
    tokendistribute: 'Distribución de tokens',
    baseinfo: 'Información de la actividad',
    status: 'Estado',
    activitytype: 'Tipo de actividad',
    activitytype0: 'Desconocido',
    activitytype1: 'Lista (FOF)',
    activitytype2: 'Lista (AVA)',
    activitytype3: 'HolderDivide',
    activitytype4: 'FreeBuy',
    activitytype5: 'MiningBuy',
    activitytype6: 'Bloqueado',
    ruledetail: 'Acerca de la regla',
    publishprice: 'Precio de publicación',
    activitycoin: 'Símbolo de moneda de actividad',
    accpetcoin: 'Aceptar símbolo de moneda',
    holdcoin: 'Sostener símbolo de moneda',
    limittimes: 'Tiempos límite personales',
    limitamount: 'Importe límite personal',
    unlimited: 'Ilimitado',
    alreadyamount: 'Importe ya vendido',
    leftamount: 'Cantidad restante',
    attention: 'Atención',
    attentiontxt1:
      '1 、 Los activos se congelarán después de enviarlos para participar en actividades de [partición de almacén] y [suscripción gratuita] hasta que se complete la descongelación.',
    attentiontxt2:
      "2 、 Los usuarios no pueden retirar su solicitud de participación después de participar en las actividades del tipo 'Holder Divide' y 'Fress Buy'",
    attentiontxt3:
      '3 、 Si la actividad se cancela debido a la parte del proyecto y otros factores de fuerza mayor, la ruta original se devolverá a los activos congelados.',
    attentiontxt4:
      '* El derecho de interpretación final de esta actividad pertenece a la titularidad oficial de NTL.',
    inputamount: 'Importe de entrada',
    inputholdamount: 'Cantidad de bloqueo de entrada',
    mybalance: 'Saldo disponible',
    holdtips: '[HolderDivide] requiere bloqueo hasta el final de la actividad.',
    pleaseinputamount: '¡Ingrese la cantidad!',
    pleaseinputholdamount: 'Por favor, ingrese la cantidad de retención',
    commitfailed: 'Confirmación fallida！',
    minlimitamountfailed:
      'La cantidad de cambio no debe ser menor que la cantidad mínima mínima de cambio.！',
    maxlimitamountfailed: 'El monto del intercambio no será mayor que el monto máximo de compra.！',
    limittimesfailed: 'Ha participado en más del número máximo de compras individuales.！',
    balancenotenough: 'El equilibrio no es suficiente！',
    headertitledesc:
      'Laboratorios abiertos para la cooperación de beneficio mutuo entre inversores, proyectores e intercambios',
    currentdivided: 'Mi posición actual obtendrá',
    leveloneCount: 'Límite de nivel uno',
    submit: 'Enviar',
    tipsmobile: 'Utilice la web de PC （ntlex.com）',
    tipsmobile1: 'Puede ingresar a la web de PC para asistir a esta actividad.',
    intvalue: 'Introduzca un valor int',
    inputminingamount: 'Input Buy Count',
    moreactivity: 'Más actividades',
    releaseType: 'Tipo de lanzamiento',
    releaseType0: 'Liberación igual',
    releaseType1: 'Lanzamiento isométrico',
    lock: 'Bloquear',
    releaseDetail: 'Detalle de la versión',
    lockday: ' Dias',
    lockweek: ' Semanas',
    lockmonth: ' Meses',
    lockyear: ' Años',
    releasePercent: 'Porcentaje de lanzamiento',
    lockFee: 'Tarifa de bloqueo',
    releaseTimes: 'Tiempos de publicación',
    times: 'tiempos',
  },
  invite: {
    inviteLoginName: 'Logi partnerina sisse',
    chengwei: 'Saada parim võimalus naasta kodumajapidamisteenistusse eluaegseks',
    pthhr: 'Hakka platvormi partneriks',
    partnerText:
      'Kutsu sõpru registreerima ja autentima oma tegelike nimedega, et nautida platvormi dividende',
    myinvitelink: 'Enlace de promoción',
    copy: 'Copiar',
    copyed: 'Copiado',
    mylevelone: 'Amigos de nivel uno',
    myleveltwo: 'Amigos del nivel dos',
    mycommission: 'Ingresos por comisiones (USDT)',
    extrareward: 'Recompensas adicionales',
    partnerlevel: 'Nivel de asociación',
    ruledetail: 'Detalles de la regla',
    ruleprofile1:
      "[Socio de promoción] es la proporción más alta de devolución de comisiones en línea y el mayor tiempo de devolución de comisiones (comisión máxima de por vida). Los promotores que hacen los esfuerzos correspondientes pueden convertirse en verdaderos 'socios' de la plataforma y disfrutar del dividendo de crecer junto con la plataforma comercial NTL . Las reglas detalladas son las siguientes: ",
    ruleprofile2: '',
    ruleprofile3: '',
    ruleprofile4: '',
    ruletext1:
      "1 、 Con el fin de predicar el concepto de activos digitales y expandir la escala de usuarios, NTL lanzó el programa' Socio de promoción ', que es efectivo durante mucho tiempo.",
    ruletext2:
      '2 、 La invitación a amigos se puede dividir en dos niveles. Si A invita a B, entonces B es el amigo de primer nivel de A. Si B invita a C, entonces C pertenece al amigo de primer nivel de B y también al amigo de segundo nivel de A. ',
    ruletext3:
      '3 、 Al promover el registro de amigos, los amigos de primer nivel de los invitados solo pueden ser los amigos de primer nivel de los invitados mediante los enlaces proporcionados por los invitados o ingresando manualmente los códigos de invitación de los invitados.',
    ruletext4:
      '4 、 After the invitee completes the registration through the invitor invitation code, the rebate incentive will take effect.',
    ruletext5:
      '5 、 The rebate period is N months from the completion of registration of the invitee. The proportion of rebate will vary according to the level of the invitee.',
    ruletext6:
      '6 、 La promoción de activos de comisión es la tarifa de transacción de la moneda amiga de nivel inferior, que son las tres monedas base del mercado, a saber, USDT, BTC y ETH.',
    ruletext7:
      '7 、 La proporción y la duración de la comisión de promoción se correlacionan positivamente con el número de amigos de primer nivel. Cuanto mayor sea el número de promoción, mayor será la proporción de comisión agradable. La promoción específica de la tasa de reembolso de la comisión es la siguiente:',
    ruletext8: '8 、 TOP10 o TOP100 recibirán incentivos adicionales de MKWORLDS de vez en cuando.',
    ruletext9:
      '9 、 Si otras actividades están en conflicto con las actividades del socio de promoción, se espera que los socios comprendan si deben cambiar temporalmente después de la consulta',
    ruletext10:
      '10 、 Los socios de nivel de enviado L4 (Xunfu), L5 (Taishou) y L6 (Jiedushi) tienen derecho a bonificaciones del 5%, 10% y 15% de las devoluciones anuales totales de la Comisión, respectivamente.',
    ruletext11: '11 、 El derecho de interpretación final de esta actividad pertenece a NTL.',
    ruleexampletitle: 'Por ejemplo:',
    ruleexamplecontent1:
      'Si el usuario Xiaoyan invitó a 100 amigos de primera clase, los amigos de primera clase de TA invitaron a cinco amigos de segunda clase, entonces Xiaoyan tenía 100 amigos de primera clase y 500 amigos de segunda clase. Si la persona promedio intercambia 3000 yuanes por día, El ingreso mensual de Xiaoyan es de aproximadamente (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%) * 30 = 7200 / mes. ',
    ruleexamplecontent2:
      "Si el usuario Xiaoyan invitó a 1000 amigos de primera clase, los amigos de primera clase de TA invitaron a 5 amigos de segunda clase, Xiaoyan tenía 1000 amigos de primera clase y 5000 amigos de segunda clase. Si la persona promedio negocia 3000 yuanes por día, Xiaoyan's mensual los ingresos son aproximadamente (1000 * 3000 * 0,001 * 50% + 5000 * 3000 * 0,001 * 20%) * 30 = 135000 / mes. ",
    lastupdate: 'Última actualización en',
    laststastic: 'Última entrada estática',
    level: 'Nivel',
    lv1: 'Lizheng',
    lv2: 'Xianling',
    lv3: 'Zhifu',
    lv4: 'Xunfu',
    lv5: 'Taishou',
    lv6: 'Jiedushi',
    levelonecount: 'Número de Levlel uno',
    levelonecommission: 'Relación de retorno de nivel uno / tiempo de retorno',
    leveltwocommission: 'Relación de retorno de nivel dos / tiempo de retorno',
    partnerdivide: 'Dividendo de socio',
    month: 'Meses',
    alllife: 'Toda la vida',
    totalcommissionrank: 'Promoción de la Comisión total',
    rank: 'No.',
    userid: 'ID de usuario',
    rankday: '(Día)',
    rankweek: '(Semana)',
    rankmonth: '(Mes)',
    rankall: '(Todas)',
    promotioncount: 'Número de promociones',
    commissionusdt: 'Comisión (USDT)',
    ranktip1:
      'La cantidad de invitaciones es la cantidad de amigos de primera clase. Esta lista clasifica la cantidad total de comisiones de grandes a pequeñas.',
    ranktip2:
      'El número de invitaciones es el número de amigos de primera clase. La lista se clasifica según el número de amigos de primera clase invitados.',
    thanks: 'Gracias por apoyar a NTL！',
    headertip:
      'Los datos anteriores no se actualizan en tiempo real. Las estadísticas del sistema y se actualizan cada 24 horas.',
    ptools: 'Herramientas de promoción',
    pt_title: 'Tarjeta de regalo de criptomonedas',
    pt_desc: 'Esto es una sorpresa del futuro, para enviar amigos, familiares, clientes, socios',
    pt_more: 'Más herramientas están por llegar',
    pt_tips:
      'Si tiene una buena idea, envíe un correo electrónico a Promotion@NTLEX.COM, con una recompensa después de la adopción.！',
    pt_card_amount: 'Monto de la tarjeta',
    pt_card_deadline: 'Fecha límite',
    pt_card_noend: 'Indefinido',
    pt_card_btn: 'Obtén 30 tarjetas gratis',
    pt_card_btn_login: 'Por favor ingresa primero',
    pt_card_rule: 'Detalles de la regla',
    pt_card_summary:
      'La tarjeta de regalo en moneda digital es una herramienta promocional desarrollada para permitir que los socios promocionales inviten mejor a amigos fuera de línea. Cuando los usuarios intercambian tarjetas de regalo, automáticamente se convertirán en amigos fuera de línea de los socios promocionales.',
    pt_card_rule1:
      '1. Las tarjetas de regalo gratuitas están limitadas a 30 tarjetas por usuario. Si es necesario emitir más tarjetas de regalo, los usuarios deben pagar por la personalización, que puede personalizar la cantidad de tarjetas, el LOGOTIPO, las instrucciones, etc. Para conocer los requisitos personalizados, por favor enviar un correo electrónico a',
    pt_card_rule2:
      '2. Las tarjetas de regalo gratuitas están limitadas a una copia por usuario. Las tarjetas de regalo gratuitas emitidas por el gobierno de NTL están limitadas a una para cada usuario. Incluso si diferentes usuarios reciben tarjetas de regalo gratis con diferentes códigos de intercambio, solo se puede canjear una. Las tarjetas de regalo personalizadas no están sujetas a esta restricción. ',
    pt_card_rule3:
      "3. Antes de que el usuario intercambie la tarjeta de regalo, si no hay 'invitador' (es decir, no se ha ingresado el código de invitación en el momento de registrar la cuenta), se asociará automáticamente con el amigo de primer nivel del emisor de la tarjeta. Si A no ingresa un código de invitación al registrar una cuenta, entonces A no pertenece a ningún amigo de primer o segundo nivel, pero cuando A se convierte en amigos de primer nivel de B a través de la tarjeta de regalo emitida por B, A se convierte automáticamente en amigos de primer nivel de B. ",
    pt_card_rule4:
      '4. Para evitar el cepillado, el valor en libros de las tarjetas de regalo no se paga en tiempo real. Se congelará durante 180 días después de la recolección y se liberará automáticamente en el saldo de la cuenta del usuario después de 180 días.',
    pt_card_rule5:
      '5. Cuando recibamos tarjetas de regalo gratuitas, debemos completar la certificación de nombre real. Al realizar la conversión, podemos obtenerlas sin completar la certificación de nombre real. Esto es para facilitar que los promotores obtengan amigos de nivel inferior más rápido.',
    pt_card_rule6:
      '6. El derecho de interpretación final de las tarjetas de regalo gratuitas pertenece a ntlex.com.',
    pt_card_day: 'Dias',
    pt_card_title_tips: 'Beca de promoción gratuita de 2000 CNY',
    pt_card_receivew_success:
      '¡Felicitaciones! ¡Colección exitosa de tarjetas de regalo de promoción para socios! Vaya al Centro personal -> Centro de tarjetas y vales',
    usepromotion: 'Utilizar materiales promocionales',
    saveimage: 'Guardar imagen',
    imagetips:
      'Si no puede descargar las imágenes correctamente, descárguelas con la herramienta de captura de pantalla',
    pt_invite_title: 'Folleto de invitación de registro',
    pt_invite_desc:
      'Automáticamente conviértase en amigos subordinados a través del registro de código bidimensional, adecuado para reenviar en varios grupos o foros.',
    colum_text0: 'Rango',
    colum_text1: 'Miembro',
    colum_text2: 'Promoción',
    colum_text3: 'Comisión (USDT)',
    colum_text4: 'Recompensa adicional',
    context_title: 'Código de canje exclusivo para socios de promoción',
    context_title1: 'Escanee para obtener más información',
    context_title2: 'Mi código de invitación',
    context_title3: 'Imagen de invitación',
  },
  uc: {
    retrieveprivate: {
      findText: 'Konto privaatvõtme hankimine',
      findText2: 'Cuenta recreada clave privada',

      inputFindtext: 'Sisesta kontoga seotud e- kiri',
      continue: 'jätka',
    },
    verify: 'Termine KYC primero',
    login: {
      welcomelogintxt: 'Tere tulemast NTL-i!',
      welcomelogintxt2: 'Kui sul pole kontot',
      welcomelogintxt3: 'Siin saab klõpsata',
      welcomelogintxt4: 'Registreeritud konto',
      welcomelogintxt5: 'Sisselogimiskonto',
      welcomelogintxt6: 'Kui teil on konto',
      welcomelogintxt7: 'Comience un nuevo viaje de trading',
      inputPrivate: 'Palun sisesta konto privaatvõti...',
      forgetPrivateTxt: 'Unustasid konto privaatvõtme?',
      phoneEmail: 'Mobiiltelefoni või e-posti sisselogimine',
      anonymousLogin: 'Anonüümne sisselogimine',
      noaccount: 'Sin cuenta？',
      register: 'Regístrate',
      login: 'Iniciar sesión',
      welcomelogin: 'Bienvenidos',
      usertip: 'Ingrese número de teléfono o correo electrónico',
      pwdtip: 'Introducir la contraseña',
      validatecodeload: 'Cargando código de verificación',
      validatemsg: 'Primero finalice la verificación',
      forget: '¿Contraseña olvidada?',
      loginvalidate: 'Ingrese el correo electrónico o el número de teléfono',
      pwdvalidate1: 'Por favor ingrese la contraseña',
      pwdvalidate2: 'Longitud de la contraseña no inferior a seis',
      success: 'Éxito',
      goregister: 'Ir al registro',
      getlostpwd: 'Contraseña olvidada',
    },
    forget: {
      title: 'Encontrar contraseña',
      hasaccount: 'Tener una cuenta？ para iniciar sesión',
      login: 'Iniciar sesión',
      sendcode: 'Enviar',
      newpwd: 'Introduzca nueva contraseña',
      confirmpwd: 'Ingrese la nueva contraseña nuevamente',
      save: 'Enviar',
      pwdvalidate1: 'Ingrese confirmar contraseña',
      pwdvalidate2: '¡La contraseña no es la misma!',
      resettelpwd: 'Restablecer contraseña de teléfono',
      resetemailpwd: 'Restablecer contraseña de correo electrónico',
      newpwdtip: 'Introduzca nueva contraseña',
      pwdvalidate3: 'Longitud de la contraseña no inferior a seis',
      telno: 'Número de teléfono',
      smscode: 'Código de verificación de SMS',
      teltip: 'Ingrese tel',
      smscodetip: 'Ingrese el código de verificación de SMS',
      email: 'Email',
      password: 'La contraseña',
      NoId: 'Aún no tienes cuenta',
      emailcode: 'Código de verificación de correo electrónico',
      emailtip: 'Ingrese correo electrónico',
      emailcodetip: 'Ingrese el código de verificación de correo electrónico',
      resetpwdsuccess: 'Restablecer contraseña correctamente',
      smswarn: 'Compruebe si hay SMS',
      bangding: 'Enlace de barrido',
      googleAuth: 'GoogleAuth',
      pleaseGoogleAuth: 'Binding GoogleAuth',
      bindGoogleAuth: 'Vinculado GoogleAuth',
      jcbind: 'Desbloquear',
    },
    finance: {
      center: 'Centro financiero',
      personalassets: 'Activos monetarios',
      swapassets: 'Intercambiar activos',
      billdetail: 'Detalle de factura',
      charge: 'Depósito',
      pickup: 'Retiro',
      tradetail: 'Comercio Minero',
      paydividends: 'Pagar dividendos',
      invitingmining: 'Invitando a los premios de minería',
      money: {
        cointype: 'Moneda',
        balance: 'Equilibrio',
        frozen: 'Balance congelado',
        operate: 'Acción',
        charge: 'Depósito',
        pickup: 'Retiro',
        onkeytrans: 'Trans',
        getaddress: 'Obtener dirección',
        resetsuccess: 'Restablecer correctamente',
        match: 'Partido',
        matchtip1: 'Importe GCX de coincidencia disponible',
        matchtip2: 'Ingrese el monto de la coincidencia',
        matcherr1: '¡Ingrese una cantidad válida!',
        matcherr2: '¡Excede el número máximo de coincidencias!',
        matchsuccess: '¡Partido exitoso!',
        needreleased: 'Activos a liberar',
        totalassets: 'Valor total estimado de los activos:',
      },
      swap: {
        totalassets: 'Valor total estimado de los activos:',
        swap: 'Cambiar',
        swaptype: 'SWAP',
        swapassets: 'Equidad de la cuenta',
        avabalance: 'Margen de Avali',
        usebalance: 'Margen utilizado',
        frozenbalance: 'Margen congelado',
        profitandloss: 'Pl no realizado',
        transfor: 'Transferir',
        inputtransferamount: 'Monto de la transferencia',
        all: 'Todas',
        currencyaccount: 'Cuenta al contado',
        swapaccount: 'Cuenta de intercambio perpetuo',
        clickchange: 'Haga clic para cambiar de dirección',
        avaamount: 'Disponible',
        pleaseselectwallet: 'Por favor, elija un puño de billetera de transferencia',
        pleaseinputamount: 'Ingrese el monto de la transferencia',
        oktransfer: 'Transferir ahora',
      },
      trade: {
        accumulative_return: 'Se han reembolsado las tarifas mineras (BHB):',
        accumulat_return: 'Las tarifas mineras deben reembolsarse (BHB):',
        start_end: 'Inicio fin',
        account_date: 'Hora de recibir el capital',
        to: 'A',
        operatetype: 'Tipo de acción',
        search: 'Buscar',
        charge: 'Cargar',
        pickup: 'Recoger',
        transaccount: 'Transferir',
        exchange: 'Intercambio',
        otcbuy: 'Compra OTC',
        otcsell: 'Venta OTC',
        activityaward: 'Premio a la actividad',
        promotionaward: 'Premio a la promoción',
        dividend: 'Dividendo',
        vote: 'Votar',
        handrecharge: 'Recarga artificial',
        match: 'Partido',
        activitybuy: 'Compra de actividad',
        ctcbuy: 'CTC-Buy',
        ctcsell: 'CTC-Sell',
        chargetime: 'tiempo de generación de pedidos',
        type: 'Tipo',
        num: 'Cantidad',
        status: 'Estado',
        finish: 'Terminado',
        fee: 'Devolución de las tarifas mineras',
        transactionTime: 'Hora de negociación',
        symbol: 'Par de monedas',
        direction: 'Dirección',
        price: 'Precio',
        entrustment: 'Entrustment',
        havedeal: 'He hecho un trato',
        poundageAmount: 'Cargo por servicio ',
        exchangeOrderId: 'El ID del pedido',
        mineAmount: 'Dig una moneda (BHB)',
        buy: 'COMPRAR',
        sell: 'VENDER',
        limit: 'LÍMITE',
        market: 'MERCADO',
        clear: 'Limpiar condición',
        turnover: 'Rotación',
      },
      inviting: {
        accumulative_return:
          'Se devolvieron y acumularon recompensas mineras por invitación (BHB):',
        accumulat_return: 'Invitar a que se devuelvan los premios mineros (BHB):',
        account_date: 'Hora de recibir el capital',
        start_end: 'Inicio fin',
        to: 'A',
        operatetype: 'Tipo de acción',
        search: 'Buscar',
        charge: 'Cargar',
        pickup: 'Recoger',
        transaccount: 'Transferir',
        exchange: 'Intercambio',
        otcbuy: 'Compra OTC',
        otcsell: 'Venta OTC',
        activityaward: 'Premio a la actividad',
        promotionaward: 'Premio a la promoción',
        dividend: 'Dividendo',
        vote: 'Votar',
        handrecharge: 'Recarga artificial',
        match: 'Partido',
        chargetime: 'tiempo de generación de pedidos',
        type: 'Tipo',
        num: 'Cantidad',
        status: 'Estado',
        finish: 'Terminado',
        fee: 'Tarifa',
        symbol: 'Símbolo de moneda',
        refereename: 'Nombre del árbitro',
        referetel: 'Número de teléfono móvil del árbitro',
        invitingawards: 'Invitación a premios de minería (BHB)',
        refere: 'Árbitro',
        refereinput: 'Ingrese el nombre / número de teléfono celular',
      },
      paydividende: {
        money_holding: 'El dinero compartido se ha devuelto y acumulado (ETH):',
        money_hold: 'Pagar dividendos para devolver (ETH):',
        paydividends: 'Pagar dividendos (ETH)',
        account_date: 'Hora de recibir el capital',
        datehodld: 'Fecha de tenencia del dinero',
        start_end: 'Inicio fin',
        to: 'A',
        operatetype: 'Tipo de acción',
        search: 'Buscar',
        charge: 'Cargar',
        pickup: 'Recoger',
        transaccount: 'Transferir',
        exchange: 'Intercambio',
        otcbuy: 'Compra OTC',
        otcsell: 'Venta OTC',
        activityaward: 'Premio a la actividad',
        promotionaward: 'Premio a la promoción',
        dividend: 'Dividendo',
        vote: 'Votar',
        handrecharge: 'Recarga artificial',
        match: 'Partido',
        chargetime: 'Tiempo de carga',
        type: 'Tipo',
        num: 'Cantidad',
        status: 'Estado',
        finish: 'Terminado',
        fee: 'Tarifa',
        symbol: 'Símbolo de moneda',
      },
      second: {
        secondaccount: 'Segunda cuenta de contrato',
        swap: ' Segunda cuenta de contrato',
      },
      finance: {
        transfer: 'transferencia financiera',
        account: 'cuenta financiera',
        balance: 'equilibrio',
        earn: 'interés acumulado',
        rate: 'tasa de interés',
        confirm: 'Confirmar transferencia',
        transferAmount: 'Monto de la transferencia',
        all: 'transferir todo',
        coin: 'divisa',
        open: 'Registro de posición',
        close: 'Registro de posiciones cerradas',
        fail: 'operación fallida',
        success: 'Operación exitosa',
        updateTime: 'tiempo de actualizacion',
        financialManagement: 'Gestión financiera',
        financialOrder: 'Orden financiero',
      },
      record: {
        start_end: 'Inicio fin',
        to: 'A',
        code: 'codificación',
        remark: 'comentar',
        operatetype: 'Tipo de acción',
        search: 'Buscar',
        charge: 'Cargar',
        pickup: 'Recoger',
        transaccount: 'Transferir',
        exchange: 'Intercambio',
        otcbuy: 'Compra OTC',
        otcsell: 'Venta OTC',
        activityaward: 'Premio a la actividad',
        promotionaward: 'Premio a la promoción',
        dividend: 'Dividendo',
        vote: 'Votar',
        handrecharge: 'Recarga artificial',
        match: 'Partido',
        chargetime: 'Tiempo de carga',
        type: 'Tipo',
        num: 'Cantidad',
        status: 'Estado',
        finish: 'Terminado',
        fee: 'Tarifa',
        shouldfee: 'Tasa a pagar',
        discountfee: 'Cargo por deducción',
        realfee: 'Cargo por servicio',
        symbol: 'Símbolo de moneda',
        activitybuy: 'Compra de actividad',
        ctcbuy: 'C2C COMPRAR',
        ctcsell: 'C2C VENTA',
        redout: 'RED-OUT',
        redin: 'RED-IN',
        quickExchange: 'Intercambio rápido',
        currentRate: 'Tipo de cambio actual',
        from: 'Desde',
        inputexchangeamount: 'Ingrese la cantidad de intercambio rápido',
        inputexchangepasswd: 'Introduzca la contraseña de Exchange',
        chooseTransCoinUnit: 'Elija Trans Coin',
        inputTransAmount: 'Elegir monto de transacción',
        predictAmount: 'Intercambiará',
        qamount: 'Amout',
        qrate: 'Velocidad',
        qexamount: 'Importe de cambio',
        withdrawcodein: 'Recarga de WithdrawCode',
        withdrawcodeout: 'WithdrawCode Retirar',
        contractfee: 'Tarifa de intercambio',
        contractprofit: 'Swap Profit',
        contractloss: 'Swap Loss',
        optionfail: 'Error de opción',
        optionfee: 'Tarifa de opción',
        optionreward: 'Opción de recompensa',
        other: 'Otro',
      },
      recharge: {
        recharge: 'Depósito',
        symbol: 'Moneda',
        address: 'Dirección de depósito',
        copy: 'Copiar',
        qrcode: 'Código QR',
        qrcodeaddress: 'QRCode para depósito',
        msg1: 'No recargue ningún activo no monetario a la dirección anterior, de lo contrario, los activos no se recuperarán',
        msg2: 'Después de recargar a la dirección anterior, debe confirmar todo el nodo de red, después de que lleguen 2 confirmaciones de red, después de que se puedan extraer 6 confirmaciones de red.',
        msg3: 'Cantidad mínima de recarga:',
        msg3_1: ', no se contabilizará la recarga inferior a la cantidad mínima.',
        msg4: 'Su dirección de recarga no cambiará con frecuencia y puede repetir la recarga; si hay algún cambio, intentaremos notificarle a través de un anuncio en el sitio web o por correo electrónico.',
        msg5: 'Asegúrese de confirmar la seguridad de su computadora y navegador para evitar que la información sea alterada o filtrada',
        record: 'Grabación',
        copysuccess: 'Éxito！',
        copyerr: 'Error！ Cópielo manualmente',
        time: 'Hora de llegada',
        amount: 'Cantidad',
        gettingaddress: 'Obteniendo la dirección de depósito, espere ...',
        getaddress: 'Obtener dirección de depósito',
        memotips: 'Por favor ingrese este Memo cuando recargue, de lo contrario perderá activos.',
        withdrawrecharge: 'Recarga por código',
        coderechargetip: 'Introduzca el código de retirada',
        rechargesuccess: '¡Felicitaciones, Recarga éxito!',
        rechargeconfirm: 'Recarga Confirmar',
        status: 'Estado',
        protocol: 'Protocolo de red',
        status_0: 'Fracaso',
        status_1: 'Cuentas pendientes',
        status_2: 'Cuenta recibida',
        protocolerr: 'Seleccione un acuerdo',
        network: 'Nodo',
        notaddress:
          'No ha solicitado una dirección de depósito，Haga clic en el botón para obtener la dirección de depósito',
        rechargeDisable: 'La función de recarga no está disponible temporalmente',
      },
      withdraw: {
        pickup: 'Recoger',
        network: 'red de transferencia',
        withdrawDisable: 'Suspender retiros',
        addressmanager: 'Gestión de direcciones',
        withdrawbycode: 'Retirar por código',
        withdrawcode: 'Retirar código',
        symbol: 'Moneda',
        address: 'Habla a',
        num: 'Cantidad',
        avabalance: 'Saldo disponible',
        msg1: 'La cantidad de monedas es menor que',
        msg2: 'Llega automáticamente a la cuenta; de lo contrario, se requiere una revisión manual',
        increase: 'Aumentar el crédito',
        tip1: 'Ingrese hasta',
        tip11: 'lugares decimales y el valor mínimo es',
        tip2: 'El valor máximo es',
        numtip1: 'Ingrese el número de monedas',
        fee: 'Tarifa',
        range: 'Rango',
        arriamount: 'El número de llegadas',
        msg3: 'El número mínimo de monedas es',
        msg4: 'moneda',
        msg5: 'Para garantizar la seguridad de los fondos, cuando la política de seguridad de su cuenta cambie, las contraseñas se cambien y utilice la nueva dirección para retirar monedas, realizaremos una auditoría manual de las monedas. Tenga paciencia y espere al personal llamar o enviar un correo electrónico. ',
        msg6: 'Asegúrese de confirmar la seguridad de su computadora y navegador para evitar que la información sea alterada o filtrada',
        record: 'Registro de retiros',
        symboltip: 'Seleccione una moneda',
        addresstip: 'Por favor, complete la dirección',
        numtip2: 'Introduzca el número correcto de monedas, el valor mínimo es',
        numtip3: 'El monto de la moneda no debe ser menor que la tarifa de procesamiento',
        amounttip: 'Ingrese el monto',
        feetip1: 'La tarifa mínima es',
        feetip2: 'El valor máximo es',
        time: 'Tiempo de espera',
        status: 'Estado',
        status_1: 'Procesando',
        status_2: 'Transfiriendo',
        status_3: 'Fallo',
        status_4: 'Éxito',
        remark: 'Observación',
        add: 'Agregar',
        addresslist: 'Lista de direcciones',
        safevalidate: 'Verificación de seguridad',
        telno: 'Tel',
        smscode: 'Código de verificación del teléfono',
        second: 'segundo',
        clickget: 'Obtener',
        email: 'Email',
        emailcode: 'Código de verificación de correo electrónico',
        save: 'Salvar',
        delete: 'Eliminar',
        telerr: 'Número de teléfono incorrecto',
        emailerr: 'Email incorrecto',
        codeerr: 'Código de verificación incorrecto',
        remarktip: 'Ingresar comentario',
        savemsg1: '¡Error al guardar!',
        savemsg2: '¡Guardado exitosamente!',
        operate: 'Operar',
        fundpwdtip: 'Introduzca la contraseña de fondos',
        click: 'clic',
        filtrate: 'puede filtrar',
        txid: 'TxId',
        generateCode: 'Generar WithdrawCode',
        withdrawcodelist: 'Lista de códigos de retiro',
        withdrawcodestatus: 'Estado',
        submit: 'Enviar',
        generatecodesuccess: '¡WithdrawCode generado!',
        code_status0: 'No usado',
        code_status3: 'éxito',
        network: 'Red de transferencia',
        protocol: 'Protocolo de red',
      },
    },
    member: {
      usercenter: 'Perfil del usuario',
      securitycenter: 'Centro de Seguridad',
      securitysetting: 'Configuración de seguridad',
      accountsetting: 'Configuración de la cuenta',
      account: 'Cuenta',
      assets: 'Finanzas',
      exchange: 'Intercambio',
      curdelegate: 'Delegado actual',
      hisdelegate: 'Delegado de Historia',
      otc: 'OTC',
    },
    order: {
      ordercenter: 'Centro de pedidos',
      myorder: 'Mi pedido',
      myad: 'Mi anuncio',
    },
    regist: {
      SaveKey: 'Por favor guarde la clave',
      zhanghaosiyao: 'Konto privaatvõti',
      logintishi:
        'Solo necesita la clave privada de la cuenta para iniciar sesión. La clave privada de la cuenta se crea localmente al azar y debe ser segura por usted mismo. Haga clic en ok para copiarla automáticamente',
      nimingtishiTxt:
        'Ingrese la clave privada de la cuenta para iniciar sesión en la cuenta. La clave privada de la cuenta se crea localmente al azar y debe ser segura por usted mismo. Si la pierde, puede recuperarla a través del correo electrónico vinculado a la cuenta. ¡De lo contrario, no podrá recuperarla!',

      shuruningcheng: 'Sisesta hüüdnimi',
      anonymousLogin: 'Anonüümne sisselogimine',
      fillInvitationCode: 'Täida kutse kood',
      go_login: 'Ya tiene una cuenta',
      go_login2: 'Ir al login',
      hasaccount: 'Tener una cuenta？ para iniciar sesión',
      login: 'Iniciar sesión',
      username: 'Nombre de usuario',
      country: 'País',
      smscode: 'Código de verificación de SMS',
      sendcode: 'Enviar',
      resendcode: 'Reenviar (',
      pwd: 'Contraseña',
      repwd: 'Confirmar contraseña',
      confrimpwd: 'Confirmar contraseña',
      agreement: 'aceptar',
      userprotocol: 'Acuerdo del Usuario',
      privacypolicy: 'Política de privacidad',

      regist: 'Regístrate',
      teltip: 'Ingrese tel',
      telerr: 'Error de formato de teléfono, vuelva a ingresar',
      emailtip: 'Ingrese correo electrónico',
      emailerr: 'Error de formato de correo electrónico, vuelva a ingresar',
      confirmpwdtip: 'Ingrese confirmar contraseña',
      confirmpwderr: '¡Dos contraseñas no son iguales!',
      telregist: 'Tel Regist',
      emailregist: 'Registro de correo electrónico',
      usernametip: 'Introduzca su nombre de usuario',
      usernamemsg: 'Longitud del nombre de usuario no menos de 3, no más de 15',
      countrytip: 'Seleccionar país',
      smscodetip: 'Ingrese el código de verificación de SMS',
      pwdtip: 'Introduzca la contraseña de inicio de sesión',
      pwdmsg: 'Longitud de la contraseña no inferior a 6',
      telno: 'Tel',
      email: 'Email',
      agreementtip: 'Haga clic para aceptar',
      reloadChoice: 'Por favor regístrese de nuevo',
      modaltitle: 'Por favor, verificación',
      promotion: 'Código de invitación opcional',
      china: 'china',
      singapore: 'Singapur',
      korea: 'Corea',
      japan: 'Japón',
      thailand: 'tailandia',
      russia: 'Rusia',
      uk: 'Reino Unido',
      vietnam: 'Vietnam',
      india: 'India',
      italy: 'Italia',
      hk: 'Hong Kong',
      malaysia: 'Malasia',
      taiwan: 'taiwán',
      turkey: 'pavo',
      germany: 'Alemania',
      france: 'Francia',
      spain: 'España',
      us: 'Estados Unidos',
      canada: 'Canadá',
    },
    safe: {
      oldprivateKey: 'Privaatvõti',
      privateKeytip: 'Palun sisesta privaatvõti',
      safelevel_low: 'Nivel de seguridad: bajo',
      safelevel_high: 'Nivel de seguridad: alto',
      safelevel_medium: 'Nivel de seguridad: Medio',
      nickname: 'Apodo',
      bind: 'Vincular',
      binded: 'Vinculado',
      verifypass: 'Verificado',
      binding: 'Vincular',
      binderr: 'Fallo',
      bindretry: 'Reintentar',
      verified: 'Verificado',
      notverified: 'No verificado',
      verifiedtip:
        'Para proteger la seguridad de su cuenta, complete la certificación del nombre real antes de poder realizar operaciones comerciales',
      realname: 'Nombre real',
      idcard: 'Tarjeta de identificación',
      upload: 'Subir',
      upload_positive: 'Subir identificación con foto al frente',
      upload_negative: 'Subir foto inversa de la tarjeta de identificación',
      upload_hand: 'Cargar fotos de identificación de la computadora de mano',
      save: 'Salvar',
      reset: 'Reiniciar',
      email: 'Email',
      bindemail: 'Enlazar correo electrónico',
      loginpwd: 'Contraseña de inicio de sesión',
      emailcode: 'Código de verificación de correo electrónico',
      clickget: 'Haga clic para obtener',
      second: 's',
      phone: 'Teléfono',
      bindphone: 'Vincular teléfono',
      phonecode: 'Código de verificación del teléfono',
      logintip: 'Úselo al iniciar sesión en la plataforma',
      edit: 'Modificar',
      oldpwd: 'Contraseña de inicio de sesión anterior',
      newpwd: 'Nueva contraseña de inicio de sesión',
      confirmnewpwd: 'Confirmar nueva contraseña',
      fundpwd: 'Contraseña del fondo',
      fundtip:
        'Cuando los fondos de la cuenta cambian, primero debe verificar la contraseña de fondos',
      set: 'Establecer',
      confirmpwd: 'Confirmar contraseña',
      oldfundpwd: 'Contraseña del fondo anterior',
      newfundpwd: 'Contraseña del nuevo fondo',
      newpwdmsg1: 'Introduzca no menos de 6 nuevas contraseñas de inicio de sesión',
      newpwdmsg2: 'La nueva contraseña de inicio de sesión no es coherente',
      pwdmsg1: 'Ingrese no menos de 6 contraseñas',
      pwdmsg2: 'Contraseña inconsistente',
      emailtip: 'Introduzca el correo electrónico',
      codetip: 'Introduzca el código de verificación',
      telnotip: 'Introduzca el número de teléfono',
      oldpwdtip: 'Introduzca la contraseña original',
      realnametip: 'Introduzca su nombre real',
      idcardtip: 'Introduzca el número de identificación',
      bindphonetip: '¡Por favor, vincule su teléfono primero!',
      resetfundpwd: 'Restablecer contraseña de fondos',
      upload_positivetip: 'Cargue el frente de la tarjeta de identificación con foto',
      upload_negativetip: 'Cargue la tarjeta de identificación con fotografía al revés',
      upload_handtip: 'Cargue fotos de identificación de la computadora de mano',
      save_success: '¡Éxito!',
      save_failure: '¡Fracaso!',
      imgtip: 'Cargue su QRCode para el efectivo del destinatario',
      idcard_verifymsg1:
        '1. El archivo tiene menos de 8M. La información en el documento debe ser claramente visible, no se permiten modificaciones en el documento o la cubierta por objetos extraños, y el número y el nombre del documento deben ser visibles.',
      idcard_verifymsg2:
        '2. La fotografía debe mostrarte sin sombrero. Se recomienda que no haya maquillaje. Los rasgos faciales de los porta documentos de mano deben ser claros y los brazos deben estar completamente expuestos.',
      idcard_verifymsg3:
        "3. Necesito tener documentos en mano y una copia manuscrita (nombre + fecha de solicitud), 'Todas mis acciones en este sitio son mis propias operaciones, y entiendo los riesgos involucrados y estoy dispuesto a asumir todas las consecuencias legales de esto cuenta.'",
    },
    account: {
      successDelete: 'Kustutamine õnnestus',
      pagetitle: 'Vincular cuenta de nombre real',
      pagetip: 'Establezca su método de pago, asegúrese de utilizar mi nombre real de cuenta',
      backcardno: 'Cuenta bancaria',
      backcardtip: 'La información de la tarjeta bancaria personal no está vinculada',
      modify: 'Modificar',
      bind: 'Vincular',
      name: 'Nombre',
      bankaccount: 'Cuenta bancaria',
      bankbranch: 'Sucursal bancaria',
      bankno: 'Número de banco',
      confirmbankno: 'Confirmar número de tarjeta',
      fundpwd: 'Contraseña del fondo',
      save: 'Salvar',
      zfbaccount: 'Cuenta de Alipay',
      zfbaccounttip: 'La cuenta personal de Alipay no está vinculada',
      wxaccount: 'Cuenta de Wechat',
      wxaccounttip: 'La cuenta personal de Wechat no está vinculada',
      banknomsg1: 'Introduzca el número de tarjeta bancaria correcto',
      banknomsg2: '¡El número de tarjeta bancaria ingresado dos veces es inconsistente!',
      verifiedmsg: 'Realice primero la autenticación del nombre real',
      bankaccountmsg: 'Seleccione su banco',
      bankbranchmsg: 'Introduzca la rama de la cuenta',
      banknomsg: 'Introduzca el número de tarjeta bancaria correcto',
      fundpwdmsg1: 'Ingrese la contraseña del fondo correcta',
      fundpwdmsg2: 'La contraseña no puede tener menos de 6 caracteres',
      zfbaccountmsg: 'Ingrese la cuenta de Alipay',
      wxaccountmsg: 'Ingrese la cuenta de WeChat',
      save_success: '¡Éxito!',
      save_failure: '¡Fracaso!',
    },
    otcorder: {
      unpaid: 'No pagado',
      paided: 'Pagado',
      finished: 'Terminado',
      canceled: 'Cancelado',
      appealing: 'Apelando',
      searchtip: 'Introduzca el número de pedido',
      orderno: 'N º de pedido',
      created: 'Hora',
      symbol: 'Moneda',
      type: 'Tipo',
      type_sell: 'vender',
      type_buy: 'comprar',
      tradename: 'Nombre comercial',
      amount: 'Cantidad',
      money: 'Dinero',
      fee: 'Tarifa',
    },
    identity: {
      certified: 'ya certificado',
      placeholder: 'Indique el motivo de la cancelación',
      apply: 'Aplicar para convertirse en empresa',
      become:
        'Conviértase en empresa certificada por NTL y disfrute de más privilegios de transacción',
      zhusnhu:
        'Las empresas disfrutan de stands publicitarios exclusivos para aumentar el éxito de las transacciones',
      tijiaoziliao: 'Enviar información de autenticación del comerciante',
      place:
        'Cargue la información de autenticación del comerciante preparada en la plataforma y envíela',
      tijiao: 'Se ha enviado su auditoría de certificación de comerciante',
      tijiaosuc: 'felicitaciones Su certificación de comerciante ha pasado',
      tijiaofail: '¡Lo siento! La certificación de su comerciante no ha pasado',
      zhuxiaotijiao: 'Se ha enviado la solicitud de cancelación de su empresa',
      shenhefail: 'Su solicitud de cancelación comercial no ha sido aprobada',
      shenhesuc: 'Su solicitud de cancelación comercial ha sido aprobada',
      shangjiazhuxiao: 'cancelación comercial',
      shenagain: 'revisión',
      shenheshibai: 'Auditoría fallida',
      sheqinggain: 'Aplicar para',
      reason: 'motivo',
      shenqingtuibao: 'Solicitar préstamo',
      getquan: 'Tiene los siguientes permisos',
      read: 'He leído y acepto',
      lijishenqing: 'Aplicar inmediatamente',
      tips: 'aviso',
      wufachexiao:
        'Estás en la operación de cancelación de negocio, luego de confirmar el envío de la operación de solicitud, no podrá ser revocada.',
      suredo: '¿Estás seguro de que esto está hecho?',
      shuzizichan: 'Certificado de comercio de activos digitales',
      gerenzichan: 'Certificado de activos digitales personales',
      second: {
        line: '¿Cómo solicitar un negocio?',
        step1: 'Paso 1: prepare los materiales de la solicitud empresarial según sea necesario',
        step1c1: 'Prepare la siguiente aplicación:',
        step1c2:
          'Número de teléfono móvil, ID de WeChat, número QQ, certificado de activo digital personal (imagen), certificado de transacción de activos digitales (imagen)',
        step2: 'Paso 2: envíe la solicitud',
        step2c:
          'Para completar los materiales de auditoría de certificación empresarial que se deben completar y cargar, haga clic en enviar para su aprobación',
        step3: 'Paso 3: auditoría de datos',
        stepc:
          'Revisaremos sus solicitudes comerciales durante los próximos tres a cinco días. Mantenga los ojos abiertos, pero puede enviar una página. Después de la aprobación, puede publicar el anuncio en el área de cambio de moneda francesa.',
        agree: 'Acordó congelar',
        agreec: 'Como depósito comercial',
        shenqingchngweishangjia: 'Solicite un negocio',
      },
      yuanyin: 'motivo',
      bizhong: 'Moneda de depósito',
      shuliang: 'Importe de margen',
      chosen: 'Seleccione la moneda',
      seat: 'Stand exclusivo',
      service: 'Servicio uno a uno',
      lowfee: 'Tarifas más bajas',
      phone: 'Teléfono',
      balance: 'Bienes personales',
      cardphoto: 'Fotos de identificación positivas y negativas',
      wx: 'Wechat',
      exchange: 'Ya sea para participar en el comercio fuera de bolsa de activos digitales',
      handphoto: 'Usuario con foto de identificación',
      qq: 'QQ',
      ploy: 'Si existe una estrategia de control de riesgos correspondiente',
      agreement: '《Acuerdo de comerciante certificado》',
      he: 'y',
      applyfor: 'Aplicar',
      sendcode: 'Enviar',
      confirm: 'Confirmar',
      prepare: 'Preparar materiales',
      result: 'Espere el resultado',
      review: 'Enviar opinión',
      passed: 'Revisión aprobada',
      approve: 'Acepte el acuerdo comercial de certificación',
      emailtip1: 'Envíe por correo electrónico los siguientes materiales a',
      emailtip2: 'Revisaremos su solicitud lo antes posible',
    },
    extension: {
      title1: 'Enlaces de promoción',
      title2: 'Amigos de promoción',
      title3: 'Mi comisión',
      linkdesc:
        'La siguiente URL es su dirección para la promoción al mundo exterior. Puede promocionarla a través de amigos, QQ, Wechat, Weibo, blogs, foros o su propio sitio web. Todas las personas que hayan accedido a través de esta dirección serán sus usuarios después de registrarse ., Y cuando estos usuarios envían estrategias en este sitio, puedes ganar comisiones, y la promoción detallada se puede ver en el registro de acceso. ',
      linktitle: 'Tus enlaces de movimiento',
      copy: 'Copiar',
      copy_msg1: 'Copiar correctamente！',
      copy_msg2: 'Error！ Cópielo manualmente',
      username: 'Nombre',
      currrecharge: 'Transacción',
      userlevel: 'Nivel de usuario',
      createdtime: 'Hora de registro',
      currcommission: 'Comisión actual',
      managerfee: 'Comisión de gestión',
      yuan: 'yuanes (RMB)',
      symbol: 'MONEDA',
      amount: 'Cantidad',
      remark: 'Observación',
      amounttime: 'Tiempo de entrega',
    },
    promotion: {
      title: 'Centro de promoción',
      subtitle1: 'Mis tarjetas',
      subtitle2: 'Intercambio de registros',
      subtitle3: 'Mi promoción',
      card_column0: 'Código de intercambio',
      card_column1: 'Nombre',
      card_column2: 'Símbolo de moneda',
      card_column3: 'Cantidad',
      card_column4: 'Fecha límite',
      card_column5: 'Total',
      card_column6: 'Intercambiado',
      card_column7: 'Crear tiempo',
      my_column0: 'Invitar usuario',
      my_column1: 'Fecha de registro',
      my_column2: 'Nombre real',
      gopromotion: 'Promoción',
      inputcardno: 'Introduzca el código de la tarjeta',
      exchange: 'Intercambio',
      exchangesuccess: 'Felicitaciones！ Puede verificar el activo en el centro financiero！',
      exchangewithcode: 'Intercambiar con código',
    },
    activity: {
      navTitle: 'Innovación',
      subNavTitle1: 'Mis ordenes',
      subNavTitle2: 'Mis minería',
      subNavTitle3: 'Mi bloqueado',
      column1: 'Nombre',
      column2: 'Tipo',
      column3: 'Cantidad',
      column4: 'Unidad (IN)',
      column5: 'Unidad (SALIDA)',
      column6: 'Estado',
      column7: 'Rotación',
      column8: 'Crear tiempo',
      mColumn1: 'Imagen',
      mColumn2: 'Nombre',
      mColumn3: 'Unidad de monedas',
      mColumn4: 'Periodo',
      mColumn5: 'MiningDays',
      mColumn6: 'MiningedDays',
      mColumn7: 'Estado',
      mColumn8: 'Capacidad base',
      mColumn9: 'Capacidad actual',
      mColumn10: 'Total minados',
      mColumn11: 'Fecha final',
      mColumn12: 'Fecha de Creación',
      lColumn1: 'Imagen',
      lColumn2: 'Nombre',
      lColumn3: 'Unidad de monedas',
      lColumn4: 'Periodo',
      lColumn5: 'LockedDays',
      lColumn6: 'ReleasedDays',
      lColumn7: 'Estado',
      lColumn8: 'Capacidad base',
      lColumn9: 'Capacidad actual',
      lColumn10: 'Total liberado',
      lColumn11: 'Fecha final',
      lColumn12: 'Fecha de Creación',
    },
    mining: {
      title: 'Mi lista de minería',
      empty: 'No hay registros',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      year: 'Año',
      invitetip1:
        'La capacidad de la máquina minera se puede mejorar invitando amigos. Cada persona invitada a cambiar la máquina minera aumentará la capacidad',
      invitetip2: 'Límite superior de aumento de capacidad',
      miningUnit: 'Unidad minera',
      miningPeriod: 'Período de minería',
      miningDays: 'Mining Times',
      miningedDays: 'Mininged Times',
      miningDaysProfit: 'Salida base',
      miningCurrentDaysProfit: 'Salida de corriente',
      status0: 'Para desplegar',
      status1: 'Desplegada',
      status2: 'Encima',
    },
    locked: {
      title: 'Mi lista bloqueada',
      empty: 'No hay registros',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      year: 'Año',
      invitetip1:
        'La capacidad del bloqueado se puede mejorar invitando amigos. Cada persona invitada a intercambiar el bloqueado aumentará la capacidad',
      invitetip2: 'Límite superior de aumento de capacidad',
      miningUnit: 'Unidad de liberación',
      miningPeriod: 'Período de lanzamiento',
      miningDays: 'Tiempos de publicación',
      miningedDays: 'Tiempos de publicación',
      miningDaysProfit: 'Salida base',
      miningCurrentDaysProfit: 'Salida de corriente',
      status0: 'Para ser lanzado',
      status1: 'Liberar',
      status2: 'Encima',
      totallocked: 'Total bloqueado',
    },
    api: {
      apiAdmin: 'Gestión de API',
      createApi: 'Crear una nueva clave API',
      mark: 'comentario',
      bindAddress: 'La clave de dirección IP independiente es válida por 90 días',
      hint: 'insinuación',
      part1:
        'Le proporcionamos una potente API, puede utilizar consultas de mercado, transacciones automáticas y otros servicios',
      apiDoc: 'por la documentación de la API',
      howUse: 'Ver cómo se usa',
      // part2: "Cada usuario crea hasta cinco conjuntos de claves API",
      part2: 'Cree hasta 5 conjuntos de claves API por usuario',
      part3:
        'No revele su clave de API para evitar la pérdida de activos. Por razones de seguridad, se recomienda vincular la IP para la clave de API, con un máximo de 5 IP para cada clave de API. Complete una sola dirección directamente, varias direcciones IP Comas angulares, como 192.168.1.1, 192.168.1.2 en su lugar, 192.168.1.3. ',
      myApiKey: 'Mi clave API',
      ipAddress: 'Dirección IP',
      // createTime: "tiempo de creación",
      createTime: 'CreateTime',
      accessKey: 'Llave de acceso',
      bindIpAddress: 'Vincular dirección IP',
      // ioDays: "Período de validez restante (días)",
      ioDays: 'Los días restantes',
      operation: 'operación',
      create: 'crear',
      edit: 'editar',
      delete: 'Eliminar',
      sureDelete: '¿Está seguro de eliminar?',
      tips: 'La clave solo se muestra cuando se agrega, por favor guárdela a tiempo.',
      copy: 'Copiar',
      access: 'llave',
      okText: 'Por supuesto',
      cancel: 'cancelar',
    },
  },
  cms: {
    NewExclusive: 'Exclusivo para recién llegados',
    Newtip:
      'Regístrese en una cuenta NTL para invitar a amigos y tener la oportunidad de obtener un reembolso de por vida',
    noticecenter: 'Centro de anuncios',
    newshelp: 'Ayuda para nuevos usuarios',
    appdownload: 'Descargar aplicación',
    onlineservice: 'Servicio en línea',
    faq: 'PREGUNTAS MÁS FRECUENTES',
    notice: 'Anuncio',
    servicecenter: 'Centro de Atención al Cliente',
    about: 'Acerca de',
    joinus: 'Únete a nosotros',
    aboutus: 'Sobre nosotros',
    exchangerule: 'Reglas comerciales',
    useprotocol: 'Acuerdo de uso',
    feenote: 'Descripción de la carga',
    merchantprocotol: 'Acuerdo comercial',
    features: 'Caracteristicas',
    contactus: 'Contáctenos',
    noticelist: 'Todos los anuncios',
    nextnotice: 'SIGUIENTE',
    prevnotice: 'ANTERIOR',
    notexist: 'La página que visitaste no existe o se ha eliminado',
    otherhelp: 'Otro en esta categoría',
    scanforshare: 'Escanear para compartir',
    download: 'Descargar',
    downloadslogan: 'APLICACIÓN NTL - Comercio en todas partes',
  },
  description: {
    title1: 'Seguridad',
    title2: 'Servicio 24H',
    title3: 'Intercambio global',
    title4: 'Proyecto estrictamente',
    message1:
      'Sistema de control de viento financiero integral y sistema antirrobo, billetera fría y caliente, sistema de firma múltiple para garantizar la seguridad de los fondos',
    message2:
      'La auditoría manual en línea 24 horas puede proteger a los clientes de perder las mejores oportunidades de inversión',
    message3:
      'La cobertura de la red de servicios comerciales globales le ayuda a invertir en activos cifrados globales y a realizar transacciones con usuarios globales',
    message4:
      'Seleccionamos estrictamente esos proyectos de blockchain de alta calidad para filtrar el 80% de los proyectos de riesgo extremadamente alto para usted',
    scanqrcode: 'Escanear el código QR, descargar la APLICACIÓN',
    aboutdesc1:
      'ntlex.com es una plataforma de comercio de activos digitales líder en el mundo, registrada en las Islas Caimán, con un equipo operativo central en Hong Kong. Los miembros principales de ntlex.com provienen de las principales empresas financieras y de Internet. La mayoría de ellos creen profundamente en Bitcoin y las cadenas de bloques. Estamos convencidos de que las cadenas de bloques cambiarán el sistema financiero monopolista tradicional y construirán una estructura social más democrática y autónoma ',
    aboutdesc2:
      'La plataforma ntlex.com tiene una arquitectura comercial de nivel financiero profesional, un motor de negociación de coincidencia de memoria concurrente de desarrollo propio. La plataforma utiliza un sistema de billetera recargable completamente frío + múltiples firmas + sistema de ataque DDOS de alta protección y otros arquitectura comercial para garantizar la seguridad de los activos del cliente. ',
    aboutdesc3:
      'Para que los clientes aprovechen mejor las oportunidades de inversión, ntlex.com adopta la gestión plana en el departamento de servicio al cliente y establece un mecanismo de respuesta de servicio extremadamente rápido. El director de servicio al cliente de activos está en línea 7 * 24 horas todo el año ronda, brindando a los clientes servicios como recarga y efectivo de activos, y asegurando que los clientes completen la recarga en 25 minutos. ',
    aboutdesc4:
      "ntlex.com supervisa estrictamente proyectos de alta calidad y proporciona servicios de alojamiento de activos seguros y estables. ntlex.com defiende el concepto de' honestidad, justicia, entusiasmo y apertura 'y se esfuerza por crear un entorno seguro, confiable y intercambio final eficiente y amigable para los usuarios. ",
    aboutdesc5:
      'Aunque los activos digitales se encuentran ahora solo en un pequeño círculo, creemos que este tipo de activos que todos pueden comprender por completo serán populares en el futuro. ¡Trabajemos juntos y esperemos que llegue!',
    aboutdesc6:
      'ntlex.com (Nano Token Liquidity) es un exchange de derivados de activos digitales internacional basado en la gobernanza de organización autónoma descentralizada (DAO), con el objetivo de proporcionar servicios de comercio de activos de blockchain seguros, estables, convenientes, justos y confiables para usuarios de todo el mundo.',
    aboutdesc7:
      'NTL DAO autoriza a una fundación en las Islas Caimán para administrar ntlex.com, lo que proporciona una estructura de gobernanza más ventajosa que la de los exchanges de criptomonedas tradicionales, lo que garantiza de manera efectiva la justicia y la seguridad de los activos de los usuarios. Los miembros del equipo de gestión provienen de diversos países y regiones de todo el mundo, y los miembros clave del equipo han trabajado en empresas financieras y tecnológicas conocidas a nivel mundial, como Coinbase, Binance, Morgan Stanley, Amazon, Google, entre otras, lo que les proporciona una gran capacidad de operación estratégica global y una rica experiencia en gestión y control de riesgos financieros.',
    aboutdesc8:
      'ntlex.com ofrece servicios de activos criptográficos integrales, que incluyen intercambio de criptomonedas, contratos perpetuos, spot, opciones, NFT, finanzas y préstamos, y admite varias versiones en diferentes idiomas, como chino, inglés, japonés, coreano, entre otros. Su solución técnica se basa en Amazon AWS y Google Cloud, lo que puede prevenir efectivamente ataques de DDOS, soportar la separación de datos dinámicos y estáticos, el almacenamiento en caché de datos calientes, la recuperación ante desastres en diferentes lugares, la expansión paralela, entre otras funciones. La tecnología de arquitectura líder en el mundo garantiza transacciones seguras para los usuarios, y también cuenta con una función de acceso a los activos de blockchain en tiempo real, tecnología de uso compartido de direcciones de múltiples monedas y múltiples verificaciones de seguridad para protección. Además, ntlex.com tiene una tarifa de negociación y extracción de activos de blockchain relativamente baja en la industria.',
    aboutdesc9:
      'Como exchange de gobernanza DAO digno de confianza para los usuarios, ntlex.com se compromete a garantizar integralmente la seguridad de la información comercial y los activos de los usuarios, y proporcionar una excelente experiencia de comercio para los usuarios.',
    support: 'Soporte',
    report: 'Sugerencia',
    service: 'Servicio al Cliente',
    apply: 'Solicitud de la junta',
    coop: 'Cooperación',
    community: 'Comunidad NTL',
    wechat: 'Wechat',
    addwechat: "Agrega 'bmate601' como amigos de Wechat y luego ingresa a la comunidad de Wechat",
    weibo: 'Weibo',
    twitter: 'Twitter',
    biyong: 'Biyong',
    telegram: 'Telegrama',
    medium: 'Medio',
    reddit: 'Reddit',
  },
  bzb_description: {
    title1: '',
    title2: '',
    title3: '',
    title4: '',
    title5: '',
    title6: '',
    title7: '',
    title8: '',
    desc1: '',
    desc2: '',
    desc3: '',
    desc4: '',
    desc5: '',
    desc6: '',
    desc7: '',
    desc8: '',
  },
  footer: {
    wechatkefu: 'servicio wechat',
    notice: 'Anuncio',
    gsmc: 'Intercambio global de activos digitales premium',
    bah: 'No. 13026899 -3, Shanghai ICP',
    gsjj: 'Perfil',
    gywm: 'Sobre nosotros',
    jrwm: 'Únete a nosotros',
    biyong: 'BiYong',
    lxwm: 'Contáctenos',
    yqlj: 'Enlaces',
    bzzx: 'Ayuda',
    xsrm: 'Un curso para principiantes',
    czzn: 'Guía de recarga',
    jyzn: 'Guía comercial',
    ptsm: 'Explique',
    fysm: 'Tarifa',
    fwtk: 'Política de servicio',
    fltk: 'política legal',
    wechat: 'Servicio al cliente de Wechat',
    xszn: 'Guía para principiantes',
    cjwt: 'PREGUNTAS MÁS FRECUENTES',
    mztk: 'Descargo de responsabilidad',
    ystk: 'Política de privacidad',
    tkxy: 'Condiciones',
    gybzb: 'Acerca de BZB',
    kfyx: 'Buzón de servicio',
    swhz: 'Cooperación',
    sbsq: 'Aplicación de mercado',
    jyzn: 'Guía de intercambio',
    bzzl: 'Información de la moneda',
    tsjb: 'Reporte',
    apidoc: 'Api Doc',
    zwkf: 'ven pronto',
  },
  index: {
    circulation: 'Circulación de fondos para la seguridad y el desarrollo',
    hourEth: 'Ingresos acumulados que se distribuirán hoy',
    yesterdayEth: 'Ingresos acumulados que se distribuirán ayer',
    yesterday: 'Salida minera del día anterior:',
    bhbTotal: 'BHB Total flux',
    bhbSecond: 'BHB Circulación de mercado de dos niveles',
    checkMineprinciple: 'Ver el principio de la minería',
    checkFlowVolum: 'Inspección de circulación',
    checkLockPosition: 'Compruebe la situación del bloqueo',
    BHBregister: 'Registro de cuenta NTL',
    tibi: 'El tiempo y límite del pago del dinero a la factura',
    line_plane:
      'Anuncio sobre el plan en línea de BHB, devolución de tarifas de circulación y servicio',
    fenpeijizhi: 'Una descripción del mecanismo de distribución de ingresos de NTL',
    jiangli_jihua: 'Invitación al programa de adjudicación de minería',
    friend_fanhuan: 'Invita amigos, gana una tarifa adicional y regresa',
  },
  plate: {
    title: 'Esquema de distribución de ingresos de la plataforma （Capital del tenedor de BHB）',
    content1:
      'Como se describe en el libro blanco, NTL asumirá el 80% de la plataforma (después de deducir impuestos y tarifas) Los ingresos se asignan a los titulares de BHB y el 20% de los ingresos se utiliza para apoyar la I + D y el funcionamiento de la plataforma. . ',
    content2:
      'La distribución de ingresos toma días como ciclo de distribución, y el 6 de junio de 2018 como primer día de distribución. Todos los días posteriores, el total de ingresos a distribuir el día anterior se asignará a los tenedores de BHB en proporción',
    content3:
      '（Aviso ： 1. El BHB aquí solo se refiere al BHB que ha sido publicado / distribuido. Ver también ',
    content3_1:
      'Nota sobre la relación de circulación de BHB / participación en la distribución de ingresos',
    content3_2:
      '2. la instantánea horaria (punto completo) se calcula una vez y la distribución de ingresos se ejecuta una vez al día.',
    hourFenpei: 'Distribución de ingresos hoy',
    hourTotal: 'Ingresos totales de la plataforma actual',
    xiangqing: 'Detalles de la distribución de ingresos actual',
    yesterdaytit: 'Distribución de ingresos ayer',
    yesterdaytotal: 'Ingresos totales de la plataforma de ayer',
    yesterdayxiangqing: 'Detalles de la distribución de ingresos de ayer',
    yesterday: {
      total: 'Ingresos totales',
      allocated: 'Ingresos no distribuidos',
    },
  },
  feereturn: {
    ruletitle: 'Nota',
    rulecontent:
      'Nuestro White Paper tiene una explicación detallada del reembolso de las tarifas de transacción. En general, el 51% de la base de BHB total de la plataforma' +
      "(a partir de ahora,' parte de recompensa de la comunidad ') se reembolsará a los usuarios a lo largo del tiempo a través de nuestro mecanismo 'Trans-Fee Mining'. Sin embargo, una vez que este 51% del total de BHBs se haya liberado por completo mediante reembolso, el mecanismo de 'Trans-Fee Mining' terminará automáticamente ",
    recordtitle: 'Lista',
    recordcontent:
      'Todos los días (UTC + 8, igual que a continuación) BHB reembolsará el 100% de las tarifas de transacción de los usuarios' +
      'incurridas desde el día anterior en forma de BHB. Esto se hará utilizando el precio promedio de BHB del día anterior (este precio promedio se calcula como el valor total de la transacción / el volumen total de la transacción). Completaremos este reembolso de las tarifas de transacción del día anterior en forma de BHB, a las 11 a. m. todos los días. ',
    time: 'Fecha',
    todaycharge: 'Precio medio (ETH)',
    totalChange: 'Total (ETH)',
    returnCharge: 'Reembolso de minería de tarifas trans (BHB)',
    todayChargeReturn: 'Programa de incentivos para el reembolso de FCoin （BHB）',
  },
};
